import _assertThisInitialized from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _toConsumableArray from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _inherits from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _asyncToGenerator from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _defineProperty from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/regenerator/index.js";
import jt, { EventEmitter as N } from "events";
import Yt from "@walletconnect/keyvaluestorage";
import { HEARTBEAT_EVENTS as j, HeartBeat as Gt } from "@walletconnect/heartbeat";
import { generateChildLogger as f, getLoggerContext as E, pino as ye, getDefaultLoggerOptions as be } from "@walletconnect/logger";
import { IMessageTracker as Ht, IPublisher as Jt, ISubscriber as Wt, IRelayer as Xt, IStore as Qt, IJsonRpcHistory as Zt, IExpirer as ei, IVerify as ti, ICore as ii } from "@walletconnect/types";
import { safeJsonStringify as si, safeJsonParse as ri } from "@walletconnect/safe-json";
import * as Y from "@walletconnect/relay-auth";
import { getInternalError as l, mapToObj as me, objToMap as fe, generateKeyPair as ni, generateRandomBytes32 as te, deriveSymKey as ai, hashKey as oi, validateEncoding as hi, isTypeOneEnvelope as Ee, encrypt as ci, validateDecoding as ui, decrypt as li, deserialize as we, decodeTypeByte as di, BASE16 as gi, hashMessage as ie, getRelayProtocolName as se, createExpiringPromise as M, getRelayProtocolApi as G, isUndefined as re, getSdkError as k, isValidArray as pi, isOnline as ve, formatRelayRpcUrl as Di, subscribeToNetworkChange as yi, isProposalStruct as bi, isSessionStruct as mi, TYPE_1 as fi, calcExpiry as H, formatUri as Ei, parseUri as wi, createDelayedPromise as vi, engineEvent as ne, isExpired as Ie, isValidParams as ae, isValidUrl as Ii, isValidString as Ci, parseExpirerTarget as Ri, formatTopicTarget as _i, formatIdTarget as Ti, isReactNative as Si, isBrowser as Pi, isNode as Oi } from "@walletconnect/utils";
import { toString as xi } from "uint8arrays";
import { ONE_DAY as U, SIX_HOURS as Ai, ONE_SECOND as Ce, THIRTY_DAYS as J, FIVE_SECONDS as Re, THIRTY_SECONDS as _e, toMiliseconds as L, TEN_SECONDS as zi, Watch as Ni, FIVE_MINUTES as Te } from "@walletconnect/time";
import { JsonRpcProvider as Ui } from "@walletconnect/jsonrpc-provider";
import { getBigIntRpcId as Li, isJsonRpcRequest as Se, isJsonRpcResponse as Pe, formatJsonRpcResult as Oe, formatJsonRpcRequest as xe, formatJsonRpcError as Fi, isJsonRpcResult as $i, isJsonRpcError as Ae } from "@walletconnect/jsonrpc-utils";
import Mi from "@walletconnect/jsonrpc-ws-connection";
import ki from "lodash.isequal";

function Ki(r, e) {
  if (r.length >= 255) throw new TypeError("Alphabet too long");

  for (var t = new Uint8Array(256), i = 0; i < t.length; i++) {
    t[i] = 255;
  }

  for (var s = 0; s < r.length; s++) {
    var n = r.charAt(s),
        a = n.charCodeAt(0);
    if (t[a] !== 255) throw new TypeError(n + " is ambiguous");
    t[a] = s;
  }

  var o = r.length,
      h = r.charAt(0),
      u = Math.log(o) / Math.log(256),
      d = Math.log(256) / Math.log(o);

  function p(c) {
    if (c instanceof Uint8Array || (ArrayBuffer.isView(c) ? c = new Uint8Array(c.buffer, c.byteOffset, c.byteLength) : Array.isArray(c) && (c = Uint8Array.from(c))), !(c instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
    if (c.length === 0) return "";

    for (var b = 0, z = 0, v = 0, _ = c.length; v !== _ && c[v] === 0;) {
      v++, b++;
    }

    for (var T = (_ - v) * d + 1 >>> 0, m = new Uint8Array(T); v !== _;) {
      for (var S = c[v], A = 0, I = T - 1; (S !== 0 || A < z) && I !== -1; I--, A++) {
        S += 256 * m[I] >>> 0, m[I] = S % o >>> 0, S = S / o >>> 0;
      }

      if (S !== 0) throw new Error("Non-zero carry");
      z = A, v++;
    }

    for (var O = T - z; O !== T && m[O] === 0;) {
      O++;
    }

    for (var q = h.repeat(b); O < T; ++O) {
      q += r.charAt(m[O]);
    }

    return q;
  }

  function y(c) {
    if (typeof c != "string") throw new TypeError("Expected String");
    if (c.length === 0) return new Uint8Array();
    var b = 0;

    if (c[b] !== " ") {
      for (var z = 0, v = 0; c[b] === h;) {
        z++, b++;
      }

      for (var _ = (c.length - b) * u + 1 >>> 0, T = new Uint8Array(_); c[b];) {
        var m = t[c.charCodeAt(b)];
        if (m === 255) return;

        for (var S = 0, A = _ - 1; (m !== 0 || S < v) && A !== -1; A--, S++) {
          m += o * T[A] >>> 0, T[A] = m % 256 >>> 0, m = m / 256 >>> 0;
        }

        if (m !== 0) throw new Error("Non-zero carry");
        v = S, b++;
      }

      if (c[b] !== " ") {
        for (var I = _ - v; I !== _ && T[I] === 0;) {
          I++;
        }

        for (var O = new Uint8Array(z + (_ - I)), q = z; I !== _;) {
          O[q++] = T[I++];
        }

        return O;
      }
    }
  }

  function $(c) {
    var b = y(c);
    if (b) return b;
    throw new Error("Non-".concat(e, " character"));
  }

  return {
    encode: p,
    decodeUnsafe: y,
    decode: $
  };
}

var Bi = Ki,
    Vi = Bi;

var ze = function ze(r) {
  if (r instanceof Uint8Array && r.constructor.name === "Uint8Array") return r;
  if (r instanceof ArrayBuffer) return new Uint8Array(r);
  if (ArrayBuffer.isView(r)) return new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
  throw new Error("Unknown type, must be binary type");
},
    qi = function qi(r) {
  return new TextEncoder().encode(r);
},
    ji = function ji(r) {
  return new TextDecoder().decode(r);
};

var Yi = /*#__PURE__*/function () {
  function Yi(e, t, i) {
    _classCallCheck(this, Yi);

    this.name = e, this.prefix = t, this.baseEncode = i;
  }

  _createClass(Yi, [{
    key: "encode",
    value: function encode(e) {
      if (e instanceof Uint8Array) return "".concat(this.prefix).concat(this.baseEncode(e));
      throw Error("Unknown type, must be binary type");
    }
  }]);

  return Yi;
}();

var Gi = /*#__PURE__*/function () {
  function Gi(e, t, i) {
    _classCallCheck(this, Gi);

    if (this.name = e, this.prefix = t, t.codePointAt(0) === void 0) throw new Error("Invalid prefix character");
    this.prefixCodePoint = t.codePointAt(0), this.baseDecode = i;
  }

  _createClass(Gi, [{
    key: "decode",
    value: function decode(e) {
      if (typeof e == "string") {
        if (e.codePointAt(0) !== this.prefixCodePoint) throw Error("Unable to decode multibase string ".concat(JSON.stringify(e), ", ").concat(this.name, " decoder only supports inputs prefixed with ").concat(this.prefix));
        return this.baseDecode(e.slice(this.prefix.length));
      } else throw Error("Can only multibase decode strings");
    }
  }, {
    key: "or",
    value: function or(e) {
      return Ne(this, e);
    }
  }]);

  return Gi;
}();

var Hi = /*#__PURE__*/function () {
  function Hi(e) {
    _classCallCheck(this, Hi);

    this.decoders = e;
  }

  _createClass(Hi, [{
    key: "or",
    value: function or(e) {
      return Ne(this, e);
    }
  }, {
    key: "decode",
    value: function decode(e) {
      var t = e[0],
          i = this.decoders[t];
      if (i) return i.decode(e);
      throw RangeError("Unable to decode multibase string ".concat(JSON.stringify(e), ", only inputs prefixed with ").concat(Object.keys(this.decoders), " are supported"));
    }
  }]);

  return Hi;
}();

var Ne = function Ne(r, e) {
  return new Hi(_objectSpread(_objectSpread({}, r.decoders || _defineProperty({}, r.prefix, r)), e.decoders || _defineProperty({}, e.prefix, e)));
};

var Ji = /*#__PURE__*/function () {
  function Ji(e, t, i, s) {
    _classCallCheck(this, Ji);

    this.name = e, this.prefix = t, this.baseEncode = i, this.baseDecode = s, this.encoder = new Yi(e, t, i), this.decoder = new Gi(e, t, s);
  }

  _createClass(Ji, [{
    key: "encode",
    value: function encode(e) {
      return this.encoder.encode(e);
    }
  }, {
    key: "decode",
    value: function decode(e) {
      return this.decoder.decode(e);
    }
  }]);

  return Ji;
}();

var W = function W(_ref3) {
  var r = _ref3.name,
      e = _ref3.prefix,
      t = _ref3.encode,
      i = _ref3.decode;
  return new Ji(r, e, t, i);
},
    K = function K(_ref4) {
  var r = _ref4.prefix,
      e = _ref4.name,
      t = _ref4.alphabet;

  var _Vi = Vi(t, e),
      i = _Vi.encode,
      s = _Vi.decode;

  return W({
    prefix: r,
    name: e,
    encode: i,
    decode: function decode(n) {
      return ze(s(n));
    }
  });
},
    Wi = function Wi(r, e, t, i) {
  var s = {};

  for (var d = 0; d < e.length; ++d) {
    s[e[d]] = d;
  }

  var n = r.length;

  for (; r[n - 1] === "=";) {
    --n;
  }

  var a = new Uint8Array(n * t / 8 | 0);
  var o = 0,
      h = 0,
      u = 0;

  for (var _d = 0; _d < n; ++_d) {
    var p = s[r[_d]];
    if (p === void 0) throw new SyntaxError("Non-".concat(i, " character"));
    h = h << t | p, o += t, o >= 8 && (o -= 8, a[u++] = 255 & h >> o);
  }

  if (o >= t || 255 & h << 8 - o) throw new SyntaxError("Unexpected end of data");
  return a;
},
    Xi = function Xi(r, e, t) {
  var i = e[e.length - 1] === "=",
      s = (1 << t) - 1;
  var n = "",
      a = 0,
      o = 0;

  for (var h = 0; h < r.length; ++h) {
    for (o = o << 8 | r[h], a += 8; a > t;) {
      a -= t, n += e[s & o >> a];
    }
  }

  if (a && (n += e[s & o << t - a]), i) for (; n.length * t & 7;) {
    n += "=";
  }
  return n;
},
    g = function g(_ref5) {
  var r = _ref5.name,
      e = _ref5.prefix,
      t = _ref5.bitsPerChar,
      i = _ref5.alphabet;
  return W({
    prefix: e,
    name: r,
    encode: function encode(s) {
      return Xi(s, i, t);
    },
    decode: function decode(s) {
      return Wi(s, i, t, r);
    }
  });
},
    Qi = W({
  prefix: "\0",
  name: "identity",
  encode: function encode(r) {
    return ji(r);
  },
  decode: function decode(r) {
    return qi(r);
  }
});

var Zi = Object.freeze({
  __proto__: null,
  identity: Qi
});
var es = g({
  prefix: "0",
  name: "base2",
  alphabet: "01",
  bitsPerChar: 1
});
var ts = Object.freeze({
  __proto__: null,
  base2: es
});
var is = g({
  prefix: "7",
  name: "base8",
  alphabet: "01234567",
  bitsPerChar: 3
});
var ss = Object.freeze({
  __proto__: null,
  base8: is
});
var rs = K({
  prefix: "9",
  name: "base10",
  alphabet: "0123456789"
});
var ns = Object.freeze({
  __proto__: null,
  base10: rs
});
var as = g({
  prefix: "f",
  name: "base16",
  alphabet: "0123456789abcdef",
  bitsPerChar: 4
}),
    os = g({
  prefix: "F",
  name: "base16upper",
  alphabet: "0123456789ABCDEF",
  bitsPerChar: 4
});
var hs = Object.freeze({
  __proto__: null,
  base16: as,
  base16upper: os
});
var cs = g({
  prefix: "b",
  name: "base32",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567",
  bitsPerChar: 5
}),
    us = g({
  prefix: "B",
  name: "base32upper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
  bitsPerChar: 5
}),
    ls = g({
  prefix: "c",
  name: "base32pad",
  alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
  bitsPerChar: 5
}),
    ds = g({
  prefix: "C",
  name: "base32padupper",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
  bitsPerChar: 5
}),
    gs = g({
  prefix: "v",
  name: "base32hex",
  alphabet: "0123456789abcdefghijklmnopqrstuv",
  bitsPerChar: 5
}),
    ps = g({
  prefix: "V",
  name: "base32hexupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
  bitsPerChar: 5
}),
    Ds = g({
  prefix: "t",
  name: "base32hexpad",
  alphabet: "0123456789abcdefghijklmnopqrstuv=",
  bitsPerChar: 5
}),
    ys = g({
  prefix: "T",
  name: "base32hexpadupper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
  bitsPerChar: 5
}),
    bs = g({
  prefix: "h",
  name: "base32z",
  alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
  bitsPerChar: 5
});
var ms = Object.freeze({
  __proto__: null,
  base32: cs,
  base32upper: us,
  base32pad: ls,
  base32padupper: ds,
  base32hex: gs,
  base32hexupper: ps,
  base32hexpad: Ds,
  base32hexpadupper: ys,
  base32z: bs
});
var fs = K({
  prefix: "k",
  name: "base36",
  alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
}),
    Es = K({
  prefix: "K",
  name: "base36upper",
  alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
var ws = Object.freeze({
  __proto__: null,
  base36: fs,
  base36upper: Es
});
var vs = K({
  name: "base58btc",
  prefix: "z",
  alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
}),
    Is = K({
  name: "base58flickr",
  prefix: "Z",
  alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
var Cs = Object.freeze({
  __proto__: null,
  base58btc: vs,
  base58flickr: Is
});

var Rs = g({
  prefix: "m",
  name: "base64",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  bitsPerChar: 6
}),
    _s = g({
  prefix: "M",
  name: "base64pad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  bitsPerChar: 6
}),
    Ts = g({
  prefix: "u",
  name: "base64url",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
  bitsPerChar: 6
}),
    Ss = g({
  prefix: "U",
  name: "base64urlpad",
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
  bitsPerChar: 6
});

var Ps = Object.freeze({
  __proto__: null,
  base64: Rs,
  base64pad: _s,
  base64url: Ts,
  base64urlpad: Ss
});
var Ue = Array.from("\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42"),
    Os = Ue.reduce(function (r, e, t) {
  return r[t] = e, r;
}, []),
    xs = Ue.reduce(function (r, e, t) {
  return r[e.codePointAt(0)] = t, r;
}, []);

function As(r) {
  return r.reduce(function (e, t) {
    return e += Os[t], e;
  }, "");
}

function zs(r) {
  var e = [];

  var _iterator = _createForOfIteratorHelper(r),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var t = _step.value;
      var i = xs[t.codePointAt(0)];
      if (i === void 0) throw new Error("Non-base256emoji character: ".concat(t));
      e.push(i);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return new Uint8Array(e);
}

var Ns = W({
  prefix: "\uD83D\uDE80",
  name: "base256emoji",
  encode: As,
  decode: zs
});
var Us = Object.freeze({
  __proto__: null,
  base256emoji: Ns
}),
    Ls = Fe,
    Le = 128,
    Fs = 127,
    $s = ~Fs,
    Ms = Math.pow(2, 31);

function Fe(r, e, t) {
  e = e || [], t = t || 0;

  for (var i = t; r >= Ms;) {
    e[t++] = r & 255 | Le, r /= 128;
  }

  for (; r & $s;) {
    e[t++] = r & 255 | Le, r >>>= 7;
  }

  return e[t] = r | 0, Fe.bytes = t - i + 1, e;
}

var ks = oe,
    Ks = 128,
    $e = 127;

function oe(r, i) {
  var t = 0,
      i = i || 0,
      s = 0,
      n = i,
      a,
      o = r.length;

  do {
    if (n >= o) throw oe.bytes = 0, new RangeError("Could not decode varint");
    a = r[n++], t += s < 28 ? (a & $e) << s : (a & $e) * Math.pow(2, s), s += 7;
  } while (a >= Ks);

  return oe.bytes = n - i, t;
}

var Bs = Math.pow(2, 7),
    Vs = Math.pow(2, 14),
    qs = Math.pow(2, 21),
    js = Math.pow(2, 28),
    Ys = Math.pow(2, 35),
    Gs = Math.pow(2, 42),
    Hs = Math.pow(2, 49),
    Js = Math.pow(2, 56),
    Ws = Math.pow(2, 63),
    Xs = function Xs(r) {
  return r < Bs ? 1 : r < Vs ? 2 : r < qs ? 3 : r < js ? 4 : r < Ys ? 5 : r < Gs ? 6 : r < Hs ? 7 : r < Js ? 8 : r < Ws ? 9 : 10;
},
    Qs = {
  encode: Ls,
  decode: ks,
  encodingLength: Xs
},
    Me = Qs;

var ke = function ke(r, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Me.encode(r, e, t), e;
},
    Ke = function Ke(r) {
  return Me.encodingLength(r);
},
    he = function he(r, e) {
  var t = e.byteLength,
      i = Ke(r),
      s = i + Ke(t),
      n = new Uint8Array(s + t);
  return ke(r, n, 0), ke(t, n, i), n.set(e, s), new Zs(r, t, e, n);
};

var Zs = /*#__PURE__*/_createClass(function Zs(e, t, i, s) {
  _classCallCheck(this, Zs);

  this.code = e, this.size = t, this.digest = i, this.bytes = s;
});

var Be = function Be(_ref6) {
  var r = _ref6.name,
      e = _ref6.code,
      t = _ref6.encode;
  return new er(r, e, t);
};

var er = /*#__PURE__*/function () {
  function er(e, t, i) {
    _classCallCheck(this, er);

    this.name = e, this.code = t, this.encode = i;
  }

  _createClass(er, [{
    key: "digest",
    value: function digest(e) {
      var _this = this;

      if (e instanceof Uint8Array) {
        var t = this.encode(e);
        return t instanceof Uint8Array ? he(this.code, t) : t.then(function (i) {
          return he(_this.code, i);
        });
      } else throw Error("Unknown type, must be binary type");
    }
  }]);

  return er;
}();

var Ve = function Ve(r) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = Uint8Array;
              _context.next = 3;
              return crypto.subtle.digest(r, e);

            case 3:
              _context.t1 = _context.sent;
              return _context.abrupt("return", new _context.t0(_context.t1));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref7.apply(this, arguments);
    };
  }();
},
    tr = Be({
  name: "sha2-256",
  code: 18,
  encode: Ve("SHA-256")
}),
    ir = Be({
  name: "sha2-512",
  code: 19,
  encode: Ve("SHA-512")
});

var sr = Object.freeze({
  __proto__: null,
  sha256: tr,
  sha512: ir
});

var qe = 0,
    rr = "identity",
    je = ze,
    nr = function nr(r) {
  return he(qe, je(r));
},
    ar = {
  code: qe,
  name: rr,
  encode: je,
  digest: nr
};

var or = Object.freeze({
  __proto__: null,
  identity: ar
});
new TextEncoder(), new TextDecoder();

var Ye = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Zi), ts), ss), ns), hs), ms), ws), Cs), Ps), Us);

_objectSpread(_objectSpread({}, sr), or);

function Ge(r) {
  return globalThis.Buffer != null ? new Uint8Array(r.buffer, r.byteOffset, r.byteLength) : r;
}

function hr() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null ? Ge(globalThis.Buffer.allocUnsafe(r)) : new Uint8Array(r);
}

function He(r, e, t, i) {
  return {
    name: r,
    prefix: e,
    encoder: {
      name: r,
      prefix: e,
      encode: t
    },
    decoder: {
      decode: i
    }
  };
}

var Je = He("utf8", "u", function (r) {
  return "u" + new TextDecoder("utf8").decode(r);
}, function (r) {
  return new TextEncoder().encode(r.substring(1));
}),
    ce = He("ascii", "a", function (r) {
  var e = "a";

  for (var t = 0; t < r.length; t++) {
    e += String.fromCharCode(r[t]);
  }

  return e;
}, function (r) {
  r = r.substring(1);
  var e = hr(r.length);

  for (var t = 0; t < r.length; t++) {
    e[t] = r.charCodeAt(t);
  }

  return e;
}),
    cr = _objectSpread({
  utf8: Je,
  "utf-8": Je,
  hex: Ye.base16,
  latin1: ce,
  ascii: ce,
  binary: ce
}, Ye);

function ur(r) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utf8";
  var t = cr[e];
  if (!t) throw new Error("Unsupported encoding \"".concat(e, "\""));
  return (e === "utf8" || e === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null ? Ge(globalThis.Buffer.from(r, "utf-8")) : t.decoder.decode("".concat(t.prefix).concat(r));
}

var ue = "wc",
    We = 2,
    X = "core",
    x = "".concat(ue, "@2:").concat(X, ":"),
    Xe = {
  name: X,
  logger: "error"
},
    Qe = {
  database: ":memory:"
},
    Ze = "crypto",
    le = "client_ed25519_seed",
    et = U,
    tt = "keychain",
    it = "0.3",
    st = "messages",
    rt = "0.3",
    nt = Ai,
    at = "publisher",
    ot = "irn",
    ht = "error",
    de = "wss://relay.walletconnect.com",
    ge = "wss://relay.walletconnect.org",
    ct = "relayer",
    D = {
  message: "relayer_message",
  message_ack: "relayer_message_ack",
  connect: "relayer_connect",
  disconnect: "relayer_disconnect",
  error: "relayer_error",
  connection_stalled: "relayer_connection_stalled",
  transport_closed: "relayer_transport_closed",
  publish: "relayer_publish"
},
    ut = "_subscription",
    P = {
  payload: "payload",
  connect: "connect",
  disconnect: "disconnect",
  error: "error"
},
    lt = Ce,
    lr = {
  database: ":memory:"
},
    dt = "2.10.1",
    gt = 1e4,
    pt = "0.3",
    Dt = "WALLETCONNECT_CLIENT_ID",
    C = {
  created: "subscription_created",
  deleted: "subscription_deleted",
  expired: "subscription_expired",
  disabled: "subscription_disabled",
  sync: "subscription_sync",
  resubscribed: "subscription_resubscribed"
},
    dr = J,
    yt = "subscription",
    bt = "0.3",
    mt = Re * 1e3,
    ft = "pairing",
    Et = "0.3",
    gr = J,
    F = {
  wc_pairingDelete: {
    req: {
      ttl: U,
      prompt: !1,
      tag: 1e3
    },
    res: {
      ttl: U,
      prompt: !1,
      tag: 1001
    }
  },
  wc_pairingPing: {
    req: {
      ttl: _e,
      prompt: !1,
      tag: 1002
    },
    res: {
      ttl: _e,
      prompt: !1,
      tag: 1003
    }
  },
  unregistered_method: {
    req: {
      ttl: U,
      prompt: !1,
      tag: 0
    },
    res: {
      ttl: U,
      prompt: !1,
      tag: 0
    }
  }
},
    B = {
  create: "pairing_create",
  expire: "pairing_expire",
  delete: "pairing_delete",
  ping: "pairing_ping"
},
    R = {
  created: "history_created",
  updated: "history_updated",
  deleted: "history_deleted",
  sync: "history_sync"
},
    wt = "history",
    vt = "0.3",
    It = "expirer",
    w = {
  created: "expirer_created",
  deleted: "expirer_deleted",
  expired: "expirer_expired",
  sync: "expirer_sync"
},
    Ct = "0.3",
    pr = U,
    Q = "verify-api",
    Z = "https://verify.walletconnect.com",
    pe = "https://verify.walletconnect.org";

var Rt = /*#__PURE__*/function () {
  function Rt(e, t) {
    var _this2 = this;

    _classCallCheck(this, Rt);

    this.core = e, this.logger = t, this.keychain = new Map(), this.name = tt, this.version = it, this.initialized = !1, this.storagePrefix = x, this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var i;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.initialized) {
                _context2.next = 5;
                break;
              }

              _context2.next = 3;
              return _this2.getKeyChain();

            case 3:
              i = _context2.sent;
              typeof i < "u" && (_this2.keychain = i), _this2.initialized = !0;

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), this.has = function (i) {
      return _this2.isInitialized(), _this2.keychain.has(i);
    }, this.set = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(i, s) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.isInitialized();

                _this2.keychain.set(i, s);

                _context3.next = 4;
                return _this2.persist();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2, _x3) {
        return _ref9.apply(this, arguments);
      };
    }(), this.get = function (i) {
      _this2.isInitialized();

      var s = _this2.keychain.get(i);

      if (typeof s > "u") {
        var _l = l("NO_MATCHING_KEY", "".concat(_this2.name, ": ").concat(i)),
            n = _l.message;

        throw new Error(n);
      }

      return s;
    }, this.del = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(i) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this2.isInitialized();

                _this2.keychain.delete(i);

                _context4.next = 4;
                return _this2.persist();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref10.apply(this, arguments);
      };
    }(), this.core = e, this.logger = f(t, this.name);
  }

  _createClass(Rt, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "setKeyChain",
    value: function () {
      var _setKeyChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.core.storage.setItem(this.storageKey, me(e));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setKeyChain(_x5) {
        return _setKeyChain.apply(this, arguments);
      }

      return setKeyChain;
    }()
  }, {
    key: "getKeyChain",
    value: function () {
      var _getKeyChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var e;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                e = _context6.sent;
                return _context6.abrupt("return", typeof e < "u" ? fe(e) : void 0);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getKeyChain() {
        return _getKeyChain.apply(this, arguments);
      }

      return getKeyChain;
    }()
  }, {
    key: "persist",
    value: function () {
      var _persist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setKeyChain(this.keychain);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function persist() {
        return _persist.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l2 = l("NOT_INITIALIZED", this.name),
            e = _l2.message;

        throw new Error(e);
      }
    }
  }]);

  return Rt;
}();

var _t = /*#__PURE__*/function () {
  function _t(e, t, i) {
    var _this3 = this;

    _classCallCheck(this, _t);

    this.core = e, this.logger = t, this.name = Ze, this.initialized = !1, this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.t0 = _this3.initialized;

              if (_context8.t0) {
                _context8.next = 5;
                break;
              }

              _context8.next = 4;
              return _this3.keychain.init();

            case 4:
              _this3.initialized = !0;

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    })), this.hasKeys = function (s) {
      return _this3.isInitialized(), _this3.keychain.has(s);
    }, this.getClientId = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var s, n;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _this3.isInitialized();

              _context9.next = 3;
              return _this3.getClientSeed();

            case 3:
              s = _context9.sent;
              n = Y.generateKeyPair(s);
              return _context9.abrupt("return", Y.encodeIss(n.publicKey));

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    })), this.generateKeyPair = function () {
      _this3.isInitialized();

      var s = ni();
      return _this3.setPrivateKey(s.publicKey, s.privateKey);
    }, this.signJWT = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(s) {
        var n, a, o, h;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this3.isInitialized();

                _context10.next = 3;
                return _this3.getClientSeed();

              case 3:
                n = _context10.sent;
                a = Y.generateKeyPair(n);
                o = te();
                h = et;
                _context10.next = 9;
                return Y.signJWT(o, s, h, a);

              case 9:
                return _context10.abrupt("return", _context10.sent);

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x6) {
        return _ref13.apply(this, arguments);
      };
    }(), this.generateSharedKey = function (s, n, a) {
      _this3.isInitialized();

      var o = _this3.getPrivateKey(s),
          h = ai(o, n);

      return _this3.setSymKey(h, a);
    }, this.setSymKey = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(s, n) {
        var a;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this3.isInitialized();

                a = n || oi(s);
                _context11.next = 4;
                return _this3.keychain.set(a, s);

              case 4:
                return _context11.abrupt("return", a);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x7, _x8) {
        return _ref14.apply(this, arguments);
      };
    }(), this.deleteKeyPair = /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(s) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this3.isInitialized();

                _context12.next = 3;
                return _this3.keychain.del(s);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x9) {
        return _ref15.apply(this, arguments);
      };
    }(), this.deleteSymKey = /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(s) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this3.isInitialized();

                _context13.next = 3;
                return _this3.keychain.del(s);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x10) {
        return _ref16.apply(this, arguments);
      };
    }(), this.encode = /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(s, n, a) {
        var o, h, y, $, u, d, p;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this3.isInitialized();

                o = hi(a), h = si(n);

                if (!Ee(o)) {
                  _context14.next = 7;
                  break;
                }

                y = o.senderPublicKey, $ = o.receiverPublicKey;
                _context14.next = 6;
                return _this3.generateSharedKey(y, $);

              case 6:
                s = _context14.sent;

              case 7:
                u = _this3.getSymKey(s), d = o.type, p = o.senderPublicKey;
                return _context14.abrupt("return", ci({
                  type: d,
                  symKey: u,
                  message: h,
                  senderPublicKey: p
                }));

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x11, _x12, _x13) {
        return _ref17.apply(this, arguments);
      };
    }(), this.decode = /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(s, n, a) {
        var o, h, u, _h, _u;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this3.isInitialized();

                o = ui(n, a);

                if (!Ee(o)) {
                  _context15.next = 7;
                  break;
                }

                h = o.receiverPublicKey, u = o.senderPublicKey;
                _context15.next = 6;
                return _this3.generateSharedKey(h, u);

              case 6:
                s = _context15.sent;

              case 7:
                _context15.prev = 7;
                _h = _this3.getSymKey(s), _u = li({
                  symKey: _h,
                  encoded: n
                });
                return _context15.abrupt("return", ri(_u));

              case 12:
                _context15.prev = 12;
                _context15.t0 = _context15["catch"](7);
                _context15.t1 = _this3.logger;
                _context15.t2 = "Failed to decode message from topic: '".concat(s, "', clientId: '");
                _context15.next = 18;
                return _this3.getClientId();

              case 18:
                _context15.t3 = _context15.sent;
                _context15.t4 = _context15.t2.concat.call(_context15.t2, _context15.t3, "'");

                _context15.t1.error.call(_context15.t1, _context15.t4);

                _this3.logger.error(_context15.t0);

              case 22:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[7, 12]]);
      }));

      return function (_x14, _x15, _x16) {
        return _ref18.apply(this, arguments);
      };
    }(), this.getPayloadType = function (s) {
      var n = we(s);
      return di(n.type);
    }, this.getPayloadSenderPublicKey = function (s) {
      var n = we(s);
      return n.senderPublicKey ? xi(n.senderPublicKey, gi) : void 0;
    }, this.core = e, this.logger = f(t, this.name), this.keychain = i || new Rt(this.core, this.logger);
  }

  _createClass(_t, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "setPrivateKey",
    value: function () {
      var _setPrivateKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(e, t) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.keychain.set(e, t);

              case 2:
                return _context16.abrupt("return", e);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function setPrivateKey(_x17, _x18) {
        return _setPrivateKey.apply(this, arguments);
      }

      return setPrivateKey;
    }()
  }, {
    key: "getPrivateKey",
    value: function getPrivateKey(e) {
      return this.keychain.get(e);
    }
  }, {
    key: "getClientSeed",
    value: function () {
      var _getClientSeed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var e;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                e = "";
                _context17.prev = 1;
                e = this.keychain.get(le);
                _context17.next = 10;
                break;

              case 5:
                _context17.prev = 5;
                _context17.t0 = _context17["catch"](1);
                e = te();
                _context17.next = 10;
                return this.keychain.set(le, e);

              case 10:
                return _context17.abrupt("return", ur(e, "base16"));

              case 11:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[1, 5]]);
      }));

      function getClientSeed() {
        return _getClientSeed.apply(this, arguments);
      }

      return getClientSeed;
    }()
  }, {
    key: "getSymKey",
    value: function getSymKey(e) {
      return this.keychain.get(e);
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l3 = l("NOT_INITIALIZED", this.name),
            e = _l3.message;

        throw new Error(e);
      }
    }
  }]);

  return _t;
}();

var Tt = /*#__PURE__*/function (_Ht) {
  _inherits(Tt, _Ht);

  var _super = _createSuper(Tt);

  function Tt(e, t) {
    var _this4;

    _classCallCheck(this, Tt);

    _this4 = _super.call(this, e, t), _this4.logger = e, _this4.core = t, _this4.messages = new Map(), _this4.name = st, _this4.version = rt, _this4.initialized = !1, _this4.storagePrefix = x, _this4.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      var i;
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (_this4.initialized) {
                _context18.next = 15;
                break;
              }

              _this4.logger.trace("Initialized");

              _context18.prev = 2;
              _context18.next = 5;
              return _this4.getRelayerMessages();

            case 5:
              i = _context18.sent;
              typeof i < "u" && (_this4.messages = i), _this4.logger.debug("Successfully Restored records for ".concat(_this4.name)), _this4.logger.trace({
                type: "method",
                method: "restore",
                size: _this4.messages.size
              });
              _context18.next = 12;
              break;

            case 9:
              _context18.prev = 9;
              _context18.t0 = _context18["catch"](2);
              _this4.logger.debug("Failed to Restore records for ".concat(_this4.name)), _this4.logger.error(_context18.t0);

            case 12:
              _context18.prev = 12;
              _this4.initialized = !0;
              return _context18.finish(12);

            case 15:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, null, [[2, 9, 12, 15]]);
    })), _this4.set = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(i, s) {
        var n, a;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _this4.isInitialized();

                n = ie(s);
                a = _this4.messages.get(i);
                typeof a > "u" && (a = {});
                _context19.t0 = typeof a[n] < "u";

                if (_context19.t0) {
                  _context19.next = 10;
                  break;
                }

                a[n] = s;

                _this4.messages.set(i, a);

                _context19.next = 10;
                return _this4.persist();

              case 10:
                return _context19.abrupt("return", n);

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x19, _x20) {
        return _ref20.apply(this, arguments);
      };
    }(), _this4.get = function (i) {
      _this4.isInitialized();

      var s = _this4.messages.get(i);

      return typeof s > "u" && (s = {}), s;
    }, _this4.has = function (i, s) {
      _this4.isInitialized();

      var n = _this4.get(i),
          a = ie(s);

      return typeof n[a] < "u";
    }, _this4.del = /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(i) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this4.isInitialized();

                _this4.messages.delete(i);

                _context20.next = 4;
                return _this4.persist();

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function (_x21) {
        return _ref21.apply(this, arguments);
      };
    }(), _this4.logger = f(e, _this4.name), _this4.core = t;
    return _this4;
  }

  _createClass(Tt, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "setRelayerMessages",
    value: function () {
      var _setRelayerMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(e) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.core.storage.setItem(this.storageKey, me(e));

              case 2:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function setRelayerMessages(_x22) {
        return _setRelayerMessages.apply(this, arguments);
      }

      return setRelayerMessages;
    }()
  }, {
    key: "getRelayerMessages",
    value: function () {
      var _getRelayerMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        var e;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                e = _context22.sent;
                return _context22.abrupt("return", typeof e < "u" ? fe(e) : void 0);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getRelayerMessages() {
        return _getRelayerMessages.apply(this, arguments);
      }

      return getRelayerMessages;
    }()
  }, {
    key: "persist",
    value: function () {
      var _persist2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.setRelayerMessages(this.messages);

              case 2:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function persist() {
        return _persist2.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l4 = l("NOT_INITIALIZED", this.name),
            e = _l4.message;

        throw new Error(e);
      }
    }
  }]);

  return Tt;
}(Ht);

var Dr = /*#__PURE__*/function (_Jt) {
  _inherits(Dr, _Jt);

  var _super2 = _createSuper(Dr);

  function Dr(e, t) {
    var _this5;

    _classCallCheck(this, Dr);

    _this5 = _super2.call(this, e, t), _this5.relayer = e, _this5.logger = t, _this5.events = new N(), _this5.name = at, _this5.queue = new Map(), _this5.publishTimeout = L(zi), _this5.needsTransportRestart = !1, _this5.publish = /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(i, s, n) {
        var a, o, h, u, d, p, y, $;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _this5.logger.debug("Publishing Payload"), _this5.logger.trace({
                  type: "method",
                  method: "publish",
                  params: {
                    topic: i,
                    message: s,
                    opts: n
                  }
                });
                _context24.prev = 1;
                o = (n === null || n === void 0 ? void 0 : n.ttl) || nt, h = se(n), u = (n === null || n === void 0 ? void 0 : n.prompt) || !1, d = (n === null || n === void 0 ? void 0 : n.tag) || 0, p = (n === null || n === void 0 ? void 0 : n.id) || Li().toString(), y = {
                  topic: i,
                  message: s,
                  opts: {
                    ttl: o,
                    relay: h,
                    prompt: u,
                    tag: d,
                    id: p
                  }
                }, $ = setTimeout(function () {
                  return _this5.queue.set(p, y);
                }, _this5.publishTimeout);
                _context24.prev = 3;
                _context24.next = 6;
                return M(_this5.rpcPublish(i, s, o, h, u, d, p), _this5.publishTimeout, "Failed to publish payload, please try again.");

              case 6:
                _context24.next = 8;
                return _context24.sent;

              case 8:
                _this5.removeRequestFromQueue(p);

                _this5.relayer.events.emit(D.publish, y);

                _context24.next = 17;
                break;

              case 12:
                _context24.prev = 12;
                _context24.t0 = _context24["catch"](3);

                if (!(_this5.logger.debug("Publishing Payload stalled"), _this5.needsTransportRestart = !0, (a = n === null || n === void 0 ? void 0 : n.internal) != null && a.throwOnFailedPublish)) {
                  _context24.next = 16;
                  break;
                }

                throw _this5.removeRequestFromQueue(p), _context24.t0;

              case 16:
                return _context24.abrupt("return");

              case 17:
                _context24.prev = 17;
                clearTimeout($);
                return _context24.finish(17);

              case 20:
                _this5.logger.debug("Successfully Published Payload"), _this5.logger.trace({
                  type: "method",
                  method: "publish",
                  params: {
                    topic: i,
                    message: s,
                    opts: n
                  }
                });
                _context24.next = 26;
                break;

              case 23:
                _context24.prev = 23;
                _context24.t1 = _context24["catch"](1);
                throw _this5.logger.debug("Failed to Publish Payload"), _this5.logger.error(_context24.t1), _context24.t1;

              case 26:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, null, [[1, 23], [3, 12, 17, 20]]);
      }));

      return function (_x23, _x24, _x25) {
        return _ref22.apply(this, arguments);
      };
    }(), _this5.on = function (i, s) {
      _this5.events.on(i, s);
    }, _this5.once = function (i, s) {
      _this5.events.once(i, s);
    }, _this5.off = function (i, s) {
      _this5.events.off(i, s);
    }, _this5.removeListener = function (i, s) {
      _this5.events.removeListener(i, s);
    }, _this5.relayer = e, _this5.logger = f(t, _this5.name), _this5.registerEventListeners();
    return _this5;
  }

  _createClass(Dr, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "rpcPublish",
    value: function rpcPublish(e, t, i, s, n, a, o) {
      var h, u, d, p;
      var y = {
        method: G(s.protocol).publish,
        params: {
          topic: e,
          message: t,
          ttl: i,
          prompt: n,
          tag: a
        },
        id: o
      };
      return re((h = y.params) == null ? void 0 : h.prompt) && ((u = y.params) == null || delete u.prompt), re((d = y.params) == null ? void 0 : d.tag) && ((p = y.params) == null || delete p.tag), this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
        type: "message",
        direction: "outgoing",
        request: y
      }), this.relayer.request(y);
    }
  }, {
    key: "removeRequestFromQueue",
    value: function removeRequestFromQueue(e) {
      this.queue.delete(e);
    }
  }, {
    key: "checkQueue",
    value: function checkQueue() {
      var _this6 = this;

      this.queue.forEach( /*#__PURE__*/function () {
        var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e) {
          var t, i, s;
          return _regeneratorRuntime.wrap(function _callee25$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  t = e.topic, i = e.message, s = e.opts;
                  _context25.next = 3;
                  return _this6.publish(t, i, s);

                case 3:
                case "end":
                  return _context25.stop();
              }
            }
          }, _callee25);
        }));

        return function (_x26) {
          return _ref23.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this7 = this;

      this.relayer.core.heartbeat.on(j.pulse, function () {
        if (_this7.needsTransportRestart) {
          _this7.needsTransportRestart = !1, _this7.relayer.events.emit(D.connection_stalled);
          return;
        }

        _this7.checkQueue();
      }), this.relayer.on(D.message_ack, function (e) {
        _this7.removeRequestFromQueue(e.id.toString());
      });
    }
  }]);

  return Dr;
}(Jt);

var yr = /*#__PURE__*/function () {
  function yr() {
    var _this8 = this;

    _classCallCheck(this, yr);

    this.map = new Map(), this.set = function (e, t) {
      var i = _this8.get(e);

      _this8.exists(e, t) || _this8.map.set(e, [].concat(_toConsumableArray(i), [t]));
    }, this.get = function (e) {
      return _this8.map.get(e) || [];
    }, this.exists = function (e, t) {
      return _this8.get(e).includes(t);
    }, this.delete = function (e, t) {
      if (typeof t > "u") {
        _this8.map.delete(e);

        return;
      }

      if (!_this8.map.has(e)) return;

      var i = _this8.get(e);

      if (!_this8.exists(e, t)) return;
      var s = i.filter(function (n) {
        return n !== t;
      });

      if (!s.length) {
        _this8.map.delete(e);

        return;
      }

      _this8.map.set(e, s);
    }, this.clear = function () {
      _this8.map.clear();
    };
  }

  _createClass(yr, [{
    key: "topics",
    get: function get() {
      return Array.from(this.map.keys());
    }
  }]);

  return yr;
}();

var br = Object.defineProperty,
    mr = Object.defineProperties,
    fr = Object.getOwnPropertyDescriptors,
    St = Object.getOwnPropertySymbols,
    Er = Object.prototype.hasOwnProperty,
    wr = Object.prototype.propertyIsEnumerable,
    Pt = function Pt(r, e, t) {
  return e in r ? br(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t;
},
    V = function V(r, e) {
  for (var t in e || (e = {})) {
    Er.call(e, t) && Pt(r, t, e[t]);
  }

  if (St) {
    var _iterator2 = _createForOfIteratorHelper(St(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var t = _step2.value;
        wr.call(e, t) && Pt(r, t, e[t]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return r;
},
    De = function De(r, e) {
  return mr(r, fr(e));
};

var Ot = /*#__PURE__*/function (_Wt) {
  _inherits(Ot, _Wt);

  var _super3 = _createSuper(Ot);

  function Ot(e, t) {
    var _this9;

    _classCallCheck(this, Ot);

    _this9 = _super3.call(this, e, t), _this9.relayer = e, _this9.logger = t, _this9.subscriptions = new Map(), _this9.topicMap = new yr(), _this9.events = new N(), _this9.name = yt, _this9.version = bt, _this9.pending = new Map(), _this9.cached = [], _this9.initialized = !1, _this9.pendingSubscriptionWatchLabel = "pending_sub_watch_label", _this9.pollingInterval = 20, _this9.storagePrefix = x, _this9.subscribeTimeout = 1e4, _this9.restartInProgress = !1, _this9.batchSubscribeTopicsLimit = 500, _this9.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.t0 = _this9.initialized;

              if (_context26.t0) {
                _context26.next = 7;
                break;
              }

              _this9.logger.trace("Initialized");

              _this9.registerEventListeners();

              _context26.next = 6;
              return _this9.relayer.core.crypto.getClientId();

            case 6:
              _this9.clientId = _context26.sent;

            case 7:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    })), _this9.subscribe = /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(i, s) {
        var n, a, o;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return _this9.restartToComplete();

              case 2:
                _this9.isInitialized();

                _this9.logger.debug("Subscribing Topic");

                _this9.logger.trace({
                  type: "method",
                  method: "subscribe",
                  params: {
                    topic: i,
                    opts: s
                  }
                });

                _context27.prev = 5;
                n = se(s), a = {
                  topic: i,
                  relay: n
                };

                _this9.pending.set(i, a);

                _context27.next = 10;
                return _this9.rpcSubscribe(i, n);

              case 10:
                o = _context27.sent;
                return _context27.abrupt("return", (_this9.onSubscribe(o, a), _this9.logger.debug("Successfully Subscribed Topic"), _this9.logger.trace({
                  type: "method",
                  method: "subscribe",
                  params: {
                    topic: i,
                    opts: s
                  }
                }), o));

              case 14:
                _context27.prev = 14;
                _context27.t0 = _context27["catch"](5);
                throw _this9.logger.debug("Failed to Subscribe Topic"), _this9.logger.error(_context27.t0), _context27.t0;

              case 17:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, null, [[5, 14]]);
      }));

      return function (_x27, _x28) {
        return _ref25.apply(this, arguments);
      };
    }(), _this9.unsubscribe = /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(i, s) {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return _this9.restartToComplete();

              case 2:
                _this9.isInitialized();

                if (!(typeof (s === null || s === void 0 ? void 0 : s.id) < "u")) {
                  _context28.next = 8;
                  break;
                }

                _context28.next = 6;
                return _this9.unsubscribeById(i, s.id, s);

              case 6:
                _context28.next = 10;
                break;

              case 8:
                _context28.next = 10;
                return _this9.unsubscribeByTopic(i, s);

              case 10:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      return function (_x29, _x30) {
        return _ref26.apply(this, arguments);
      };
    }(), _this9.isSubscribed = /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(i) {
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (!_this9.topics.includes(i)) {
                  _context29.next = 4;
                  break;
                }

                _context29.t0 = !0;
                _context29.next = 7;
                break;

              case 4:
                _context29.next = 6;
                return new Promise(function (s, n) {
                  var a = new Ni();
                  a.start(_this9.pendingSubscriptionWatchLabel);
                  var o = setInterval(function () {
                    !_this9.pending.has(i) && _this9.topics.includes(i) && (clearInterval(o), a.stop(_this9.pendingSubscriptionWatchLabel), s(!0)), a.elapsed(_this9.pendingSubscriptionWatchLabel) >= mt && (clearInterval(o), a.stop(_this9.pendingSubscriptionWatchLabel), n(new Error("Subscription resolution timeout")));
                  }, _this9.pollingInterval);
                }).catch(function () {
                  return !1;
                });

              case 6:
                _context29.t0 = _context29.sent;

              case 7:
                return _context29.abrupt("return", _context29.t0);

              case 8:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      return function (_x31) {
        return _ref27.apply(this, arguments);
      };
    }(), _this9.on = function (i, s) {
      _this9.events.on(i, s);
    }, _this9.once = function (i, s) {
      _this9.events.once(i, s);
    }, _this9.off = function (i, s) {
      _this9.events.off(i, s);
    }, _this9.removeListener = function (i, s) {
      _this9.events.removeListener(i, s);
    }, _this9.restart = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
      return _regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _this9.restartInProgress = !0;
              _context30.next = 3;
              return _this9.restore();

            case 3:
              _context30.next = 5;
              return _this9.reset();

            case 5:
              _this9.restartInProgress = !1;

            case 6:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    })), _this9.relayer = e, _this9.logger = f(t, _this9.name), _this9.clientId = "";
    return _this9;
  }

  _createClass(Ot, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "length",
    get: function get() {
      return this.subscriptions.size;
    }
  }, {
    key: "ids",
    get: function get() {
      return Array.from(this.subscriptions.keys());
    }
  }, {
    key: "values",
    get: function get() {
      return Array.from(this.subscriptions.values());
    }
  }, {
    key: "topics",
    get: function get() {
      return this.topicMap.topics;
    }
  }, {
    key: "hasSubscription",
    value: function hasSubscription(e, t) {
      var i = !1;

      try {
        i = this.getSubscription(e).topic === t;
      } catch (_unused2) {}

      return i;
    }
  }, {
    key: "onEnable",
    value: function onEnable() {
      this.cached = [], this.initialized = !0;
    }
  }, {
    key: "onDisable",
    value: function onDisable() {
      this.cached = this.values, this.subscriptions.clear(), this.topicMap.clear();
    }
  }, {
    key: "unsubscribeByTopic",
    value: function () {
      var _unsubscribeByTopic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(e, t) {
        var _this10 = this;

        var i;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                i = this.topicMap.get(e);
                _context32.next = 3;
                return Promise.all(i.map( /*#__PURE__*/function () {
                  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(s) {
                    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
                      while (1) {
                        switch (_context31.prev = _context31.next) {
                          case 0:
                            _context31.next = 2;
                            return _this10.unsubscribeById(e, s, t);

                          case 2:
                            return _context31.abrupt("return", _context31.sent);

                          case 3:
                          case "end":
                            return _context31.stop();
                        }
                      }
                    }, _callee31);
                  }));

                  return function (_x34) {
                    return _ref29.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function unsubscribeByTopic(_x32, _x33) {
        return _unsubscribeByTopic.apply(this, arguments);
      }

      return unsubscribeByTopic;
    }()
  }, {
    key: "unsubscribeById",
    value: function () {
      var _unsubscribeById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(e, t, i) {
        var s, n;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                this.logger.debug("Unsubscribing Topic"), this.logger.trace({
                  type: "method",
                  method: "unsubscribe",
                  params: {
                    topic: e,
                    id: t,
                    opts: i
                  }
                });
                _context33.prev = 1;
                s = se(i);
                _context33.next = 5;
                return this.rpcUnsubscribe(e, t, s);

              case 5:
                n = k("USER_DISCONNECTED", "".concat(this.name, ", ").concat(e));
                _context33.next = 8;
                return this.onUnsubscribe(e, t, n);

              case 8:
                this.logger.debug("Successfully Unsubscribed Topic");
                this.logger.trace({
                  type: "method",
                  method: "unsubscribe",
                  params: {
                    topic: e,
                    id: t,
                    opts: i
                  }
                });
                _context33.next = 15;
                break;

              case 12:
                _context33.prev = 12;
                _context33.t0 = _context33["catch"](1);
                throw this.logger.debug("Failed to Unsubscribe Topic"), this.logger.error(_context33.t0), _context33.t0;

              case 15:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this, [[1, 12]]);
      }));

      function unsubscribeById(_x35, _x36, _x37) {
        return _unsubscribeById.apply(this, arguments);
      }

      return unsubscribeById;
    }()
  }, {
    key: "rpcSubscribe",
    value: function () {
      var _rpcSubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(e, t) {
        var i;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                i = {
                  method: G(t.protocol).subscribe,
                  params: {
                    topic: e
                  }
                };
                this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
                  type: "payload",
                  direction: "outgoing",
                  request: i
                });
                _context34.prev = 2;
                _context34.next = 5;
                return M(this.relayer.request(i), this.subscribeTimeout);

              case 5:
                _context34.next = 7;
                return _context34.sent;

              case 7:
                _context34.next = 12;
                break;

              case 9:
                _context34.prev = 9;
                _context34.t0 = _context34["catch"](2);
                this.logger.debug("Outgoing Relay Subscribe Payload stalled"), this.relayer.events.emit(D.connection_stalled);

              case 12:
                return _context34.abrupt("return", ie(e + this.clientId));

              case 13:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this, [[2, 9]]);
      }));

      function rpcSubscribe(_x38, _x39) {
        return _rpcSubscribe.apply(this, arguments);
      }

      return rpcSubscribe;
    }()
  }, {
    key: "rpcBatchSubscribe",
    value: function () {
      var _rpcBatchSubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(e) {
        var t, i;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                if (e.length) {
                  _context35.next = 2;
                  break;
                }

                return _context35.abrupt("return");

              case 2:
                t = e[0].relay, i = {
                  method: G(t.protocol).batchSubscribe,
                  params: {
                    topics: e.map(function (s) {
                      return s.topic;
                    })
                  }
                };
                this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
                  type: "payload",
                  direction: "outgoing",
                  request: i
                });
                _context35.prev = 4;
                _context35.next = 7;
                return M(this.relayer.request(i), this.subscribeTimeout);

              case 7:
                _context35.next = 9;
                return _context35.sent;

              case 9:
                return _context35.abrupt("return", _context35.sent);

              case 12:
                _context35.prev = 12;
                _context35.t0 = _context35["catch"](4);
                this.logger.debug("Outgoing Relay Payload stalled"), this.relayer.events.emit(D.connection_stalled);

              case 15:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this, [[4, 12]]);
      }));

      function rpcBatchSubscribe(_x40) {
        return _rpcBatchSubscribe.apply(this, arguments);
      }

      return rpcBatchSubscribe;
    }()
  }, {
    key: "rpcUnsubscribe",
    value: function rpcUnsubscribe(e, t, i) {
      var s = {
        method: G(i.protocol).unsubscribe,
        params: {
          topic: e,
          id: t
        }
      };
      return this.logger.debug("Outgoing Relay Payload"), this.logger.trace({
        type: "payload",
        direction: "outgoing",
        request: s
      }), this.relayer.request(s);
    }
  }, {
    key: "onSubscribe",
    value: function onSubscribe(e, t) {
      this.setSubscription(e, De(V({}, t), {
        id: e
      })), this.pending.delete(t.topic);
    }
  }, {
    key: "onBatchSubscribe",
    value: function onBatchSubscribe(e) {
      var _this11 = this;

      e.length && e.forEach(function (t) {
        _this11.setSubscription(t.id, V({}, t)), _this11.pending.delete(t.topic);
      });
    }
  }, {
    key: "onUnsubscribe",
    value: function () {
      var _onUnsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(e, t, i) {
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                this.events.removeAllListeners(t);
                this.hasSubscription(t, e) && this.deleteSubscription(t, i);
                _context36.next = 4;
                return this.relayer.messages.del(e);

              case 4:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function onUnsubscribe(_x41, _x42, _x43) {
        return _onUnsubscribe.apply(this, arguments);
      }

      return onUnsubscribe;
    }()
  }, {
    key: "setRelayerSubscriptions",
    value: function () {
      var _setRelayerSubscriptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(e) {
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return this.relayer.core.storage.setItem(this.storageKey, e);

              case 2:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function setRelayerSubscriptions(_x44) {
        return _setRelayerSubscriptions.apply(this, arguments);
      }

      return setRelayerSubscriptions;
    }()
  }, {
    key: "getRelayerSubscriptions",
    value: function () {
      var _getRelayerSubscriptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this.relayer.core.storage.getItem(this.storageKey);

              case 2:
                return _context38.abrupt("return", _context38.sent);

              case 3:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function getRelayerSubscriptions() {
        return _getRelayerSubscriptions.apply(this, arguments);
      }

      return getRelayerSubscriptions;
    }()
  }, {
    key: "setSubscription",
    value: function setSubscription(e, t) {
      this.subscriptions.has(e) || (this.logger.debug("Setting subscription"), this.logger.trace({
        type: "method",
        method: "setSubscription",
        id: e,
        subscription: t
      }), this.addSubscription(e, t));
    }
  }, {
    key: "addSubscription",
    value: function addSubscription(e, t) {
      this.subscriptions.set(e, V({}, t)), this.topicMap.set(t.topic, e), this.events.emit(C.created, t);
    }
  }, {
    key: "getSubscription",
    value: function getSubscription(e) {
      this.logger.debug("Getting subscription"), this.logger.trace({
        type: "method",
        method: "getSubscription",
        id: e
      });
      var t = this.subscriptions.get(e);

      if (!t) {
        var _l5 = l("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)),
            i = _l5.message;

        throw new Error(i);
      }

      return t;
    }
  }, {
    key: "deleteSubscription",
    value: function deleteSubscription(e, t) {
      this.logger.debug("Deleting subscription"), this.logger.trace({
        type: "method",
        method: "deleteSubscription",
        id: e,
        reason: t
      });
      var i = this.getSubscription(e);
      this.subscriptions.delete(e), this.topicMap.delete(i.topic, e), this.events.emit(C.deleted, De(V({}, i), {
        reason: t
      }));
    }
  }, {
    key: "persist",
    value: function () {
      var _persist3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.setRelayerSubscriptions(this.values);

              case 2:
                this.events.emit(C.sync);

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function persist() {
        return _persist3.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
        var e, t, i;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (!this.cached.length) {
                  _context40.next = 10;
                  break;
                }

                e = Math.ceil(this.cached.length / this.batchSubscribeTopicsLimit);
                t = 0;

              case 3:
                if (!(t < e)) {
                  _context40.next = 10;
                  break;
                }

                i = this.cached.splice(0, this.batchSubscribeTopicsLimit);
                _context40.next = 7;
                return this.batchSubscribe(i);

              case 7:
                t++;
                _context40.next = 3;
                break;

              case 10:
                this.events.emit(C.resubscribed);

              case 11:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var e, _l6, t;

        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.prev = 0;
                _context41.next = 3;
                return this.getRelayerSubscriptions();

              case 3:
                e = _context41.sent;

                if (!(typeof e > "u" || !e.length)) {
                  _context41.next = 6;
                  break;
                }

                return _context41.abrupt("return");

              case 6:
                if (!this.subscriptions.size) {
                  _context41.next = 9;
                  break;
                }

                _l6 = l("RESTORE_WILL_OVERRIDE", this.name), t = _l6.message;
                throw this.logger.error(t), this.logger.error("".concat(this.name, ": ").concat(JSON.stringify(this.values))), new Error(t);

              case 9:
                this.cached = e, this.logger.debug("Successfully Restored subscriptions for ".concat(this.name)), this.logger.trace({
                  type: "method",
                  method: "restore",
                  subscriptions: this.values
                });
                _context41.next = 15;
                break;

              case 12:
                _context41.prev = 12;
                _context41.t0 = _context41["catch"](0);
                this.logger.debug("Failed to Restore subscriptions for ".concat(this.name)), this.logger.error(_context41.t0);

              case 15:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this, [[0, 12]]);
      }));

      function restore() {
        return _restore.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "batchSubscribe",
    value: function () {
      var _batchSubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (e.length) {
                  _context42.next = 2;
                  break;
                }

                return _context42.abrupt("return");

              case 2:
                _context42.next = 4;
                return this.rpcBatchSubscribe(e);

              case 4:
                t = _context42.sent;
                pi(t) && this.onBatchSubscribe(t.map(function (i, s) {
                  return De(V({}, e[s]), {
                    id: i
                  });
                }));

              case 6:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function batchSubscribe(_x45) {
        return _batchSubscribe.apply(this, arguments);
      }

      return batchSubscribe;
    }()
  }, {
    key: "onConnect",
    value: function () {
      var _onConnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.t0 = this.restartInProgress;

                if (_context43.t0) {
                  _context43.next = 5;
                  break;
                }

                _context43.next = 4;
                return this.restart();

              case 4:
                this.onEnable();

              case 5:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function onConnect() {
        return _onConnect.apply(this, arguments);
      }

      return onConnect;
    }()
  }, {
    key: "onDisconnect",
    value: function onDisconnect() {
      this.onDisable();
    }
  }, {
    key: "checkPending",
    value: function () {
      var _checkPending = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        var e;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if (!(!this.initialized || this.relayer.transportExplicitlyClosed)) {
                  _context44.next = 2;
                  break;
                }

                return _context44.abrupt("return");

              case 2:
                e = [];
                this.pending.forEach(function (t) {
                  e.push(t);
                });
                _context44.next = 6;
                return this.batchSubscribe(e);

              case 6:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function checkPending() {
        return _checkPending.apply(this, arguments);
      }

      return checkPending;
    }()
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this12 = this;

      this.relayer.core.heartbeat.on(j.pulse, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return _this12.checkPending();

              case 2:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }))), this.relayer.on(D.connect, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return _this12.onConnect();

              case 2:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }))), this.relayer.on(D.disconnect, function () {
        _this12.onDisconnect();
      }), this.events.on(C.created, /*#__PURE__*/function () {
        var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee47$(_context47) {
            while (1) {
              switch (_context47.prev = _context47.next) {
                case 0:
                  t = C.created;

                  _this12.logger.info("Emitting ".concat(t));

                  _this12.logger.debug({
                    type: "event",
                    event: t,
                    data: e
                  });

                  _context47.next = 5;
                  return _this12.persist();

                case 5:
                case "end":
                  return _context47.stop();
              }
            }
          }, _callee47);
        }));

        return function (_x46) {
          return _ref32.apply(this, arguments);
        };
      }()), this.events.on(C.deleted, /*#__PURE__*/function () {
        var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee48$(_context48) {
            while (1) {
              switch (_context48.prev = _context48.next) {
                case 0:
                  t = C.deleted;

                  _this12.logger.info("Emitting ".concat(t));

                  _this12.logger.debug({
                    type: "event",
                    event: t,
                    data: e
                  });

                  _context48.next = 5;
                  return _this12.persist();

                case 5:
                case "end":
                  return _context48.stop();
              }
            }
          }, _callee48);
        }));

        return function (_x47) {
          return _ref33.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l7 = l("NOT_INITIALIZED", this.name),
            e = _l7.message;

        throw new Error(e);
      }
    }
  }, {
    key: "restartToComplete",
    value: function () {
      var _restartToComplete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
        var _this13 = this;

        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _context49.t0 = this.restartInProgress;

                if (!_context49.t0) {
                  _context49.next = 4;
                  break;
                }

                _context49.next = 4;
                return new Promise(function (e) {
                  var t = setInterval(function () {
                    _this13.restartInProgress || (clearInterval(t), e());
                  }, _this13.pollingInterval);
                });

              case 4:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function restartToComplete() {
        return _restartToComplete.apply(this, arguments);
      }

      return restartToComplete;
    }()
  }]);

  return Ot;
}(Wt);

var vr = Object.defineProperty,
    xt = Object.getOwnPropertySymbols,
    Ir = Object.prototype.hasOwnProperty,
    Cr = Object.prototype.propertyIsEnumerable,
    At = function At(r, e, t) {
  return e in r ? vr(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t;
},
    Rr = function Rr(r, e) {
  for (var t in e || (e = {})) {
    Ir.call(e, t) && At(r, t, e[t]);
  }

  if (xt) {
    var _iterator3 = _createForOfIteratorHelper(xt(e)),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var t = _step3.value;
        Cr.call(e, t) && At(r, t, e[t]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return r;
};

var zt = /*#__PURE__*/function (_Xt) {
  _inherits(zt, _Xt);

  var _super4 = _createSuper(zt);

  function zt(e) {
    var _this14;

    _classCallCheck(this, zt);

    _this14 = _super4.call(this, e), _this14.protocol = "wc", _this14.version = 2, _this14.events = new N(), _this14.name = ct, _this14.transportExplicitlyClosed = !1, _this14.initialized = !1, _this14.connectionAttemptInProgress = !1, _this14.connectionStatusPollingInterval = 20, _this14.staleConnectionErrors = ["socket hang up", "socket stalled"], _this14.hasExperiencedNetworkDisruption = !1, _this14.request = /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(t) {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _this14.logger.debug("Publishing Request Payload");

                _context50.prev = 1;
                _context50.next = 4;
                return _this14.toEstablishConnection();

              case 4:
                _context50.next = 6;
                return _this14.provider.request(t);

              case 6:
                return _context50.abrupt("return", _context50.sent);

              case 9:
                _context50.prev = 9;
                _context50.t0 = _context50["catch"](1);
                throw _this14.logger.debug("Failed to Publish Request"), _this14.logger.error(_context50.t0), _context50.t0;

              case 12:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, null, [[1, 9]]);
      }));

      return function (_x48) {
        return _ref34.apply(this, arguments);
      };
    }(), _this14.onPayloadHandler = function (t) {
      _this14.onProviderPayload(t);
    }, _this14.onConnectHandler = function () {
      _this14.events.emit(D.connect);
    }, _this14.onDisconnectHandler = function () {
      _this14.onProviderDisconnect();
    }, _this14.onProviderErrorHandler = function (t) {
      _this14.logger.error(t), _this14.events.emit(D.error, t), _this14.logger.info("Fatal socket error received, closing transport"), _this14.transportClose();
    }, _this14.registerProviderListeners = function () {
      _this14.provider.on(P.payload, _this14.onPayloadHandler), _this14.provider.on(P.connect, _this14.onConnectHandler), _this14.provider.on(P.disconnect, _this14.onDisconnectHandler), _this14.provider.on(P.error, _this14.onProviderErrorHandler);
    }, _this14.core = e.core, _this14.logger = typeof e.logger < "u" && typeof e.logger != "string" ? f(e.logger, _this14.name) : ye(be({
      level: e.logger || ht
    })), _this14.messages = new Tt(_this14.logger, e.core), _this14.subscriber = new Ot(_assertThisInitialized(_this14), _this14.logger), _this14.publisher = new Dr(_assertThisInitialized(_this14), _this14.logger), _this14.relayUrl = (e === null || e === void 0 ? void 0 : e.relayUrl) || de, _this14.projectId = e.projectId, _this14.provider = {};
    return _this14;
  }

  _createClass(zt, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
        var _this15 = this;

        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                this.logger.trace("Initialized");
                this.registerEventListeners();
                _context52.next = 4;
                return this.createProvider();

              case 4:
                _context52.next = 6;
                return Promise.all([this.messages.init(), this.subscriber.init()]);

              case 6:
                _context52.prev = 6;
                _context52.next = 9;
                return this.transportOpen();

              case 9:
                _context52.next = 16;
                break;

              case 11:
                _context52.prev = 11;
                _context52.t0 = _context52["catch"](6);
                this.logger.warn("Connection via ".concat(this.relayUrl, " failed, attempting to connect via failover domain ").concat(ge, "..."));
                _context52.next = 16;
                return this.restartTransport(ge);

              case 16:
                this.initialized = !0, setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
                  return _regeneratorRuntime.wrap(function _callee51$(_context51) {
                    while (1) {
                      switch (_context51.prev = _context51.next) {
                        case 0:
                          _context51.t0 = _this15.subscriber.topics.length === 0;

                          if (!_context51.t0) {
                            _context51.next = 6;
                            break;
                          }

                          _this15.logger.info("No topics subscribed to after init, closing transport");

                          _context51.next = 5;
                          return _this15.transportClose();

                        case 5:
                          _this15.transportExplicitlyClosed = !1;

                        case 6:
                        case "end":
                          return _context51.stop();
                      }
                    }
                  }, _callee51);
                })), gt);

              case 17:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this, [[6, 11]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "connected",
    get: function get() {
      return this.provider.connection.connected;
    }
  }, {
    key: "connecting",
    get: function get() {
      return this.provider.connection.connecting;
    }
  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(e, t, i) {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                this.isInitialized();
                _context53.next = 3;
                return this.publisher.publish(e, t, i);

              case 3:
                _context53.next = 5;
                return this.recordMessageEvent({
                  topic: e,
                  message: t,
                  publishedAt: Date.now()
                });

              case 5:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));

      function publish(_x49, _x50, _x51) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(e, t) {
        var _this16 = this;

        var i, s;
        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                this.isInitialized();
                s = ((i = this.subscriber.topicMap.get(e)) == null ? void 0 : i[0]) || "";
                _context55.t0 = s;

                if (_context55.t0) {
                  _context55.next = 7;
                  break;
                }

                _context55.next = 6;
                return Promise.all([new Promise(function (n) {
                  _this16.subscriber.once(C.created, function (a) {
                    a.topic === e && n();
                  });
                }), new Promise( /*#__PURE__*/function () {
                  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(n) {
                    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
                      while (1) {
                        switch (_context54.prev = _context54.next) {
                          case 0:
                            _context54.next = 2;
                            return _this16.subscriber.subscribe(e, t);

                          case 2:
                            s = _context54.sent;
                            n();

                          case 4:
                          case "end":
                            return _context54.stop();
                        }
                      }
                    }, _callee54);
                  }));

                  return function (_x54) {
                    return _ref36.apply(this, arguments);
                  };
                }())]);

              case 6:
                _context55.t0 = s;

              case 7:
                return _context55.abrupt("return", _context55.t0);

              case 8:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function subscribe(_x52, _x53) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(e, t) {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                this.isInitialized();
                _context56.next = 3;
                return this.subscriber.unsubscribe(e, t);

              case 3:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function unsubscribe(_x55, _x56) {
        return _unsubscribe.apply(this, arguments);
      }

      return unsubscribe;
    }()
  }, {
    key: "on",
    value: function on(e, t) {
      this.events.on(e, t);
    }
  }, {
    key: "once",
    value: function once(e, t) {
      this.events.once(e, t);
    }
  }, {
    key: "off",
    value: function off(e, t) {
      this.events.off(e, t);
    }
  }, {
    key: "removeListener",
    value: function removeListener(e, t) {
      this.events.removeListener(e, t);
    }
  }, {
    key: "transportClose",
    value: function () {
      var _transportClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57() {
        var _this17 = this;

        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                this.transportExplicitlyClosed = !0;

                if (!(this.hasExperiencedNetworkDisruption && this.connected)) {
                  _context57.next = 6;
                  break;
                }

                _context57.next = 4;
                return M(this.provider.disconnect(), 1e3, "provider.disconnect()").catch(function () {
                  return _this17.onProviderDisconnect();
                });

              case 4:
                _context57.next = 10;
                break;

              case 6:
                _context57.t0 = this.connected;

                if (!_context57.t0) {
                  _context57.next = 10;
                  break;
                }

                _context57.next = 10;
                return this.provider.disconnect();

              case 10:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function transportClose() {
        return _transportClose.apply(this, arguments);
      }

      return transportClose;
    }()
  }, {
    key: "transportOpen",
    value: function () {
      var _transportOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(e) {
        var _this18 = this;

        var i;
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                this.transportExplicitlyClosed = !1;
                _context59.next = 3;
                return this.confirmOnlineStateOrThrow();

              case 3:
                if (this.connectionAttemptInProgress) {
                  _context59.next = 27;
                  break;
                }

                _context59.t0 = e && e !== this.relayUrl;

                if (!_context59.t0) {
                  _context59.next = 11;
                  break;
                }

                this.relayUrl = e;
                _context59.next = 9;
                return this.transportClose();

              case 9:
                _context59.next = 11;
                return this.createProvider();

              case 11:
                this.connectionAttemptInProgress = !0;
                _context59.prev = 12;
                _context59.next = 15;
                return Promise.all([new Promise(function (t) {
                  if (!_this18.initialized) return t();

                  _this18.subscriber.once(C.resubscribed, function () {
                    t();
                  });
                }), new Promise( /*#__PURE__*/function () {
                  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(t, i) {
                    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
                      while (1) {
                        switch (_context58.prev = _context58.next) {
                          case 0:
                            _context58.prev = 0;
                            _context58.next = 3;
                            return M(_this18.provider.connect(), 1e4, "Socket stalled when trying to connect to ".concat(_this18.relayUrl));

                          case 3:
                            _context58.next = 9;
                            break;

                          case 5:
                            _context58.prev = 5;
                            _context58.t0 = _context58["catch"](0);
                            i(_context58.t0);
                            return _context58.abrupt("return");

                          case 9:
                            t();

                          case 10:
                          case "end":
                            return _context58.stop();
                        }
                      }
                    }, _callee58, null, [[0, 5]]);
                  }));

                  return function (_x58, _x59) {
                    return _ref37.apply(this, arguments);
                  };
                }())]);

              case 15:
                _context59.next = 24;
                break;

              case 17:
                _context59.prev = 17;
                _context59.t1 = _context59["catch"](12);
                this.logger.error(_context59.t1);
                i = _context59.t1;

                if (this.isConnectionStalled(i.message)) {
                  _context59.next = 23;
                  break;
                }

                throw _context59.t1;

              case 23:
                this.provider.events.emit(P.disconnect);

              case 24:
                _context59.prev = 24;
                this.connectionAttemptInProgress = !1, this.hasExperiencedNetworkDisruption = !1;
                return _context59.finish(24);

              case 27:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this, [[12, 17, 24, 27]]);
      }));

      function transportOpen(_x57) {
        return _transportOpen.apply(this, arguments);
      }

      return transportOpen;
    }()
  }, {
    key: "restartTransport",
    value: function () {
      var _restartTransport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(e) {
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return this.confirmOnlineStateOrThrow();

              case 2:
                _context60.t0 = !this.connectionAttemptInProgress;

                if (!_context60.t0) {
                  _context60.next = 11;
                  break;
                }

                this.relayUrl = e || this.relayUrl;
                _context60.next = 7;
                return this.transportClose();

              case 7:
                _context60.next = 9;
                return this.createProvider();

              case 9:
                _context60.next = 11;
                return this.transportOpen();

              case 11:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));

      function restartTransport(_x60) {
        return _restartTransport.apply(this, arguments);
      }

      return restartTransport;
    }()
  }, {
    key: "confirmOnlineStateOrThrow",
    value: function () {
      var _confirmOnlineStateOrThrow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61() {
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.next = 2;
                return ve();

              case 2:
                if (_context61.sent) {
                  _context61.next = 4;
                  break;
                }

                throw new Error("No internet connection detected. Please restart your network and try again.");

              case 4:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61);
      }));

      function confirmOnlineStateOrThrow() {
        return _confirmOnlineStateOrThrow.apply(this, arguments);
      }

      return confirmOnlineStateOrThrow;
    }()
  }, {
    key: "isConnectionStalled",
    value: function isConnectionStalled(e) {
      return this.staleConnectionErrors.some(function (t) {
        return e.includes(t);
      });
    }
  }, {
    key: "createProvider",
    value: function () {
      var _createProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
        var e;
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                this.provider.connection && this.unregisterProviderListeners();
                _context62.next = 3;
                return this.core.crypto.signJWT(this.relayUrl);

              case 3:
                e = _context62.sent;
                this.provider = new Ui(new Mi(Di({
                  sdkVersion: dt,
                  protocol: this.protocol,
                  version: this.version,
                  relayUrl: this.relayUrl,
                  projectId: this.projectId,
                  auth: e,
                  useOnCloseEvent: !0
                }))), this.registerProviderListeners();

              case 5:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));

      function createProvider() {
        return _createProvider.apply(this, arguments);
      }

      return createProvider;
    }()
  }, {
    key: "recordMessageEvent",
    value: function () {
      var _recordMessageEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(e) {
        var t, i;
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                t = e.topic, i = e.message;
                _context63.next = 3;
                return this.messages.set(t, i);

              case 3:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));

      function recordMessageEvent(_x61) {
        return _recordMessageEvent.apply(this, arguments);
      }

      return recordMessageEvent;
    }()
  }, {
    key: "shouldIgnoreMessageEvent",
    value: function () {
      var _shouldIgnoreMessageEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(e) {
        var t, i, s;
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                t = e.topic, i = e.message;

                if (!(!i || i.length === 0)) {
                  _context64.next = 3;
                  break;
                }

                return _context64.abrupt("return", (this.logger.debug("Ignoring invalid/empty message: ".concat(i)), !0));

              case 3:
                _context64.next = 5;
                return this.subscriber.isSubscribed(t);

              case 5:
                if (_context64.sent) {
                  _context64.next = 7;
                  break;
                }

                return _context64.abrupt("return", (this.logger.debug("Ignoring message for non-subscribed topic ".concat(t)), !0));

              case 7:
                s = this.messages.has(t, i);
                return _context64.abrupt("return", (s && this.logger.debug("Ignoring duplicate message: ".concat(i)), s));

              case 9:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, this);
      }));

      function shouldIgnoreMessageEvent(_x62) {
        return _shouldIgnoreMessageEvent.apply(this, arguments);
      }

      return shouldIgnoreMessageEvent;
    }()
  }, {
    key: "onProviderPayload",
    value: function () {
      var _onProviderPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(e) {
        var t, _t$data, i, s, n, a;

        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                if (!(this.logger.debug("Incoming Relay Payload"), this.logger.trace({
                  type: "payload",
                  direction: "incoming",
                  payload: e
                }), Se(e))) {
                  _context65.next = 13;
                  break;
                }

                if (e.method.endsWith(ut)) {
                  _context65.next = 3;
                  break;
                }

                return _context65.abrupt("return");

              case 3:
                t = e.params, _t$data = t.data, i = _t$data.topic, s = _t$data.message, n = _t$data.publishedAt, a = {
                  topic: i,
                  message: s,
                  publishedAt: n
                };
                this.logger.debug("Emitting Relayer Payload");
                this.logger.trace(Rr({
                  type: "event",
                  event: t.id
                }, a));
                this.events.emit(t.id, a);
                _context65.next = 9;
                return this.acknowledgePayload(e);

              case 9:
                _context65.next = 11;
                return this.onMessageEvent(a);

              case 11:
                _context65.next = 14;
                break;

              case 13:
                Pe(e) && this.events.emit(D.message_ack, e);

              case 14:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, this);
      }));

      function onProviderPayload(_x63) {
        return _onProviderPayload.apply(this, arguments);
      }

      return onProviderPayload;
    }()
  }, {
    key: "onMessageEvent",
    value: function () {
      var _onMessageEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(e) {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                _context66.next = 2;
                return this.shouldIgnoreMessageEvent(e);

              case 2:
                _context66.t0 = _context66.sent;

                if (_context66.t0) {
                  _context66.next = 7;
                  break;
                }

                this.events.emit(D.message, e);
                _context66.next = 7;
                return this.recordMessageEvent(e);

              case 7:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, this);
      }));

      function onMessageEvent(_x64) {
        return _onMessageEvent.apply(this, arguments);
      }

      return onMessageEvent;
    }()
  }, {
    key: "acknowledgePayload",
    value: function () {
      var _acknowledgePayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(e) {
        var t;
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                t = Oe(e.id, !0);
                _context67.next = 3;
                return this.provider.connection.send(t);

              case 3:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, this);
      }));

      function acknowledgePayload(_x65) {
        return _acknowledgePayload.apply(this, arguments);
      }

      return acknowledgePayload;
    }()
  }, {
    key: "unregisterProviderListeners",
    value: function unregisterProviderListeners() {
      this.provider.off(P.payload, this.onPayloadHandler), this.provider.off(P.connect, this.onConnectHandler), this.provider.off(P.disconnect, this.onDisconnectHandler), this.provider.off(P.error, this.onProviderErrorHandler);
    }
  }, {
    key: "registerEventListeners",
    value: function () {
      var _registerEventListeners = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69() {
        var _this19 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                this.events.on(D.connection_stalled, function () {
                  _this19.restartTransport().catch(function (t) {
                    return _this19.logger.error(t);
                  });
                });
                _context69.next = 3;
                return ve();

              case 3:
                e = _context69.sent;
                yi( /*#__PURE__*/function () {
                  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(t) {
                    return _regeneratorRuntime.wrap(function _callee68$(_context68) {
                      while (1) {
                        switch (_context68.prev = _context68.next) {
                          case 0:
                            _context68.t0 = _this19.initialized && e !== t;

                            if (!_context68.t0) {
                              _context68.next = 11;
                              break;
                            }

                            e = t;

                            if (!t) {
                              _context68.next = 8;
                              break;
                            }

                            _context68.next = 6;
                            return _this19.restartTransport().catch(function (i) {
                              return _this19.logger.error(i);
                            });

                          case 6:
                            _context68.next = 11;
                            break;

                          case 8:
                            _this19.hasExperiencedNetworkDisruption = !0;
                            _context68.next = 11;
                            return _this19.transportClose().catch(function (i) {
                              return _this19.logger.error(i);
                            });

                          case 11:
                          case "end":
                            return _context68.stop();
                        }
                      }
                    }, _callee68);
                  }));

                  return function (_x66) {
                    return _ref38.apply(this, arguments);
                  };
                }());

              case 5:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this);
      }));

      function registerEventListeners() {
        return _registerEventListeners.apply(this, arguments);
      }

      return registerEventListeners;
    }()
  }, {
    key: "onProviderDisconnect",
    value: function onProviderDisconnect() {
      this.events.emit(D.disconnect), this.attemptToReconnect();
    }
  }, {
    key: "attemptToReconnect",
    value: function attemptToReconnect() {
      var _this20 = this;

      this.transportExplicitlyClosed || (this.logger.info("attemptToReconnect called. Connecting..."), setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70() {
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                _context70.next = 2;
                return _this20.restartTransport().catch(function (e) {
                  return _this20.logger.error(e);
                });

              case 2:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70);
      })), L(lt)));
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l8 = l("NOT_INITIALIZED", this.name),
            e = _l8.message;

        throw new Error(e);
      }
    }
  }, {
    key: "toEstablishConnection",
    value: function () {
      var _toEstablishConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71() {
        var _this21 = this;

        return _regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                _context71.next = 2;
                return this.confirmOnlineStateOrThrow();

              case 2:
                if (this.connected) {
                  _context71.next = 9;
                  break;
                }

                if (!this.connectionAttemptInProgress) {
                  _context71.next = 7;
                  break;
                }

                _context71.next = 6;
                return new Promise(function (e) {
                  var t = setInterval(function () {
                    _this21.connected && (clearInterval(t), e());
                  }, _this21.connectionStatusPollingInterval);
                });

              case 6:
                return _context71.abrupt("return", _context71.sent);

              case 7:
                _context71.next = 9;
                return this.restartTransport();

              case 9:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, this);
      }));

      function toEstablishConnection() {
        return _toEstablishConnection.apply(this, arguments);
      }

      return toEstablishConnection;
    }()
  }]);

  return zt;
}(Xt);

var _r = Object.defineProperty,
    Nt = Object.getOwnPropertySymbols,
    Tr = Object.prototype.hasOwnProperty,
    Sr = Object.prototype.propertyIsEnumerable,
    Ut = function Ut(r, e, t) {
  return e in r ? _r(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t;
},
    Lt = function Lt(r, e) {
  for (var t in e || (e = {})) {
    Tr.call(e, t) && Ut(r, t, e[t]);
  }

  if (Nt) {
    var _iterator4 = _createForOfIteratorHelper(Nt(e)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var t = _step4.value;
        Sr.call(e, t) && Ut(r, t, e[t]);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return r;
};

var Ft = /*#__PURE__*/function (_Qt) {
  _inherits(Ft, _Qt);

  var _super5 = _createSuper(Ft);

  function Ft(e, t, i) {
    var _this22;

    var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : x;
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : void 0;

    _classCallCheck(this, Ft);

    _this22 = _super5.call(this, e, t, i, s), _this22.core = e, _this22.logger = t, _this22.name = i, _this22.map = new Map(), _this22.version = pt, _this22.cached = [], _this22.initialized = !1, _this22.storagePrefix = x, _this22.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72() {
      return _regeneratorRuntime.wrap(function _callee72$(_context72) {
        while (1) {
          switch (_context72.prev = _context72.next) {
            case 0:
              _context72.t0 = _this22.initialized;

              if (_context72.t0) {
                _context72.next = 8;
                break;
              }

              _this22.logger.trace("Initialized");

              _context72.next = 5;
              return _this22.restore();

            case 5:
              _this22.cached.forEach(function (a) {
                _this22.getKey && a !== null && !re(a) ? _this22.map.set(_this22.getKey(a), a) : bi(a) ? _this22.map.set(a.id, a) : mi(a) && _this22.map.set(a.topic, a);
              });

              _this22.cached = [];
              _this22.initialized = !0;

            case 8:
            case "end":
              return _context72.stop();
          }
        }
      }, _callee72);
    })), _this22.set = /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(a, o) {
        return _regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                _this22.isInitialized();

                if (!_this22.map.has(a)) {
                  _context73.next = 6;
                  break;
                }

                _context73.next = 4;
                return _this22.update(a, o);

              case 4:
                _context73.next = 11;
                break;

              case 6:
                _this22.logger.debug("Setting value");

                _this22.logger.trace({
                  type: "method",
                  method: "set",
                  key: a,
                  value: o
                });

                _this22.map.set(a, o);

                _context73.next = 11;
                return _this22.persist();

              case 11:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73);
      }));

      return function (_x67, _x68) {
        return _ref41.apply(this, arguments);
      };
    }(), _this22.get = function (a) {
      return _this22.isInitialized(), _this22.logger.debug("Getting value"), _this22.logger.trace({
        type: "method",
        method: "get",
        key: a
      }), _this22.getData(a);
    }, _this22.getAll = function (a) {
      return _this22.isInitialized(), a ? _this22.values.filter(function (o) {
        return Object.keys(a).every(function (h) {
          return ki(o[h], a[h]);
        });
      }) : _this22.values;
    }, _this22.update = /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(a, o) {
        var h;
        return _regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                _this22.isInitialized(), _this22.logger.debug("Updating value"), _this22.logger.trace({
                  type: "method",
                  method: "update",
                  key: a,
                  update: o
                });
                h = Lt(Lt({}, _this22.getData(a)), o);

                _this22.map.set(a, h);

                _context74.next = 5;
                return _this22.persist();

              case 5:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74);
      }));

      return function (_x69, _x70) {
        return _ref42.apply(this, arguments);
      };
    }(), _this22.delete = /*#__PURE__*/function () {
      var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(a, o) {
        return _regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                _this22.isInitialized();

                _context75.t0 = _this22.map.has(a);

                if (!_context75.t0) {
                  _context75.next = 8;
                  break;
                }

                _this22.logger.debug("Deleting value");

                _this22.logger.trace({
                  type: "method",
                  method: "delete",
                  key: a,
                  reason: o
                });

                _this22.map.delete(a);

                _context75.next = 8;
                return _this22.persist();

              case 8:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75);
      }));

      return function (_x71, _x72) {
        return _ref43.apply(this, arguments);
      };
    }(), _this22.logger = f(t, _this22.name), _this22.storagePrefix = s, _this22.getKey = n;
    return _this22;
  }

  _createClass(Ft, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "length",
    get: function get() {
      return this.map.size;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.map.keys());
    }
  }, {
    key: "values",
    get: function get() {
      return Array.from(this.map.values());
    }
  }, {
    key: "setDataStore",
    value: function () {
      var _setDataStore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(e) {
        return _regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                _context76.next = 2;
                return this.core.storage.setItem(this.storageKey, e);

              case 2:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, this);
      }));

      function setDataStore(_x73) {
        return _setDataStore.apply(this, arguments);
      }

      return setDataStore;
    }()
  }, {
    key: "getDataStore",
    value: function () {
      var _getDataStore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77() {
        return _regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                _context77.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                return _context77.abrupt("return", _context77.sent);

              case 3:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, this);
      }));

      function getDataStore() {
        return _getDataStore.apply(this, arguments);
      }

      return getDataStore;
    }()
  }, {
    key: "getData",
    value: function getData(e) {
      var t = this.map.get(e);

      if (!t) {
        var _l9 = l("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)),
            i = _l9.message;

        throw this.logger.error(i), new Error(i);
      }

      return t;
    }
  }, {
    key: "persist",
    value: function () {
      var _persist4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78() {
        return _regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                _context78.next = 2;
                return this.setDataStore(this.values);

              case 2:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, this);
      }));

      function persist() {
        return _persist4.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79() {
        var e, _l10, t;

        return _regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                _context79.prev = 0;
                _context79.next = 3;
                return this.getDataStore();

              case 3:
                e = _context79.sent;

                if (!(typeof e > "u" || !e.length)) {
                  _context79.next = 6;
                  break;
                }

                return _context79.abrupt("return");

              case 6:
                if (!this.map.size) {
                  _context79.next = 9;
                  break;
                }

                _l10 = l("RESTORE_WILL_OVERRIDE", this.name), t = _l10.message;
                throw this.logger.error(t), new Error(t);

              case 9:
                this.cached = e, this.logger.debug("Successfully Restored value for ".concat(this.name)), this.logger.trace({
                  type: "method",
                  method: "restore",
                  value: this.values
                });
                _context79.next = 15;
                break;

              case 12:
                _context79.prev = 12;
                _context79.t0 = _context79["catch"](0);
                this.logger.debug("Failed to Restore value for ".concat(this.name)), this.logger.error(_context79.t0);

              case 15:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, this, [[0, 12]]);
      }));

      function restore() {
        return _restore2.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l11 = l("NOT_INITIALIZED", this.name),
            e = _l11.message;

        throw new Error(e);
      }
    }
  }]);

  return Ft;
}(Qt);

var $t = /*#__PURE__*/function () {
  function $t(e, t) {
    var _this23 = this;

    _classCallCheck(this, $t);

    this.core = e, this.logger = t, this.name = ft, this.version = Et, this.events = new jt(), this.initialized = !1, this.storagePrefix = x, this.ignoredPayloadTypes = [fi], this.registeredMethods = [], this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80() {
      return _regeneratorRuntime.wrap(function _callee80$(_context80) {
        while (1) {
          switch (_context80.prev = _context80.next) {
            case 0:
              _context80.t0 = _this23.initialized;

              if (_context80.t0) {
                _context80.next = 10;
                break;
              }

              _context80.next = 4;
              return _this23.pairings.init();

            case 4:
              _context80.next = 6;
              return _this23.cleanup();

            case 6:
              _this23.registerRelayerEvents();

              _this23.registerExpirerEvents();

              _this23.initialized = !0;

              _this23.logger.trace("Initialized");

            case 10:
            case "end":
              return _context80.stop();
          }
        }
      }, _callee80);
    })), this.register = function (_ref45) {
      var i = _ref45.methods;
      _this23.isInitialized(), _this23.registeredMethods = _toConsumableArray(new Set([].concat(_toConsumableArray(_this23.registeredMethods), _toConsumableArray(i))));
    }, this.create = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81() {
      var i, s, n, a, o, h;
      return _regeneratorRuntime.wrap(function _callee81$(_context81) {
        while (1) {
          switch (_context81.prev = _context81.next) {
            case 0:
              _this23.isInitialized();

              i = te();
              _context81.next = 4;
              return _this23.core.crypto.setSymKey(i);

            case 4:
              s = _context81.sent;
              n = H(Te);
              a = {
                protocol: ot
              };
              o = {
                topic: s,
                expiry: n,
                relay: a,
                active: !1
              };
              h = Ei({
                protocol: _this23.core.protocol,
                version: _this23.core.version,
                topic: s,
                symKey: i,
                relay: a
              });
              _context81.next = 11;
              return _this23.pairings.set(s, o);

            case 11:
              _context81.next = 13;
              return _this23.core.relayer.subscribe(s);

            case 13:
              _this23.core.expirer.set(s, n);

              return _context81.abrupt("return", {
                topic: s,
                uri: h
              });

            case 15:
            case "end":
              return _context81.stop();
          }
        }
      }, _callee81);
    })), this.pair = /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(i) {
        var _wi, s, n, a, o, h, u;

        return _regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                _this23.isInitialized(), _this23.isValidPair(i);
                _wi = wi(i.uri), s = _wi.topic, n = _wi.symKey, a = _wi.relay;

                if (!(_this23.pairings.keys.includes(s) && (o = _this23.pairings.get(s), o.active))) {
                  _context82.next = 4;
                  break;
                }

                throw new Error("Pairing already exists: ".concat(s, ". Please try again with a new connection URI."));

              case 4:
                _context82.t0 = _this23.core.crypto.keychain.has(s);

                if (_context82.t0) {
                  _context82.next = 10;
                  break;
                }

                _context82.next = 8;
                return _this23.core.crypto.setSymKey(n, s);

              case 8:
                _context82.next = 10;
                return _this23.core.relayer.subscribe(s, {
                  relay: a
                });

              case 10:
                h = H(Te), u = {
                  topic: s,
                  relay: a,
                  expiry: h,
                  active: !1
                };
                _context82.next = 13;
                return _this23.pairings.set(s, u);

              case 13:
                _this23.core.expirer.set(s, h);

                _context82.t1 = i.activatePairing;

                if (!_context82.t1) {
                  _context82.next = 18;
                  break;
                }

                _context82.next = 18;
                return _this23.activate({
                  topic: s
                });

              case 18:
                _this23.events.emit(B.create, u);

                return _context82.abrupt("return", u);

              case 20:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82);
      }));

      return function (_x74) {
        return _ref47.apply(this, arguments);
      };
    }(), this.activate = /*#__PURE__*/function () {
      var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83(_ref48) {
        var i, s;
        return _regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                i = _ref48.topic;

                _this23.isInitialized();

                s = H(J);
                _context83.next = 5;
                return _this23.pairings.update(i, {
                  active: !0,
                  expiry: s
                });

              case 5:
                _this23.core.expirer.set(i, s);

              case 6:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83);
      }));

      return function (_x75) {
        return _ref49.apply(this, arguments);
      };
    }(), this.ping = /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(i) {
        var s, n, _vi, a, o, h;

        return _regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                _this23.isInitialized();

                _context84.next = 3;
                return _this23.isValidPing(i);

              case 3:
                s = i.topic;

                if (!_this23.pairings.keys.includes(s)) {
                  _context84.next = 15;
                  break;
                }

                _context84.next = 7;
                return _this23.sendRequest(s, "wc_pairingPing", {});

              case 7:
                n = _context84.sent;
                _vi = vi();
                a = _vi.done;
                o = _vi.resolve;
                h = _vi.reject;

                _this23.events.once(ne("pairing_ping", n), function (_ref51) {
                  var u = _ref51.error;
                  u ? h(u) : o();
                });

                _context84.next = 15;
                return a();

              case 15:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84);
      }));

      return function (_x76) {
        return _ref50.apply(this, arguments);
      };
    }(), this.updateExpiry = /*#__PURE__*/function () {
      var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(_ref52) {
        var i, s;
        return _regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                i = _ref52.topic, s = _ref52.expiry;

                _this23.isInitialized();

                _context85.next = 4;
                return _this23.pairings.update(i, {
                  expiry: s
                });

              case 4:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85);
      }));

      return function (_x77) {
        return _ref53.apply(this, arguments);
      };
    }(), this.updateMetadata = /*#__PURE__*/function () {
      var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(_ref54) {
        var i, s;
        return _regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                i = _ref54.topic, s = _ref54.metadata;

                _this23.isInitialized();

                _context86.next = 4;
                return _this23.pairings.update(i, {
                  peerMetadata: s
                });

              case 4:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86);
      }));

      return function (_x78) {
        return _ref55.apply(this, arguments);
      };
    }(), this.getPairings = function () {
      return _this23.isInitialized(), _this23.pairings.values;
    }, this.disconnect = /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(i) {
        var s;
        return _regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                _this23.isInitialized();

                _context87.next = 3;
                return _this23.isValidDisconnect(i);

              case 3:
                s = i.topic;
                _context87.t0 = _this23.pairings.keys.includes(s);

                if (!_context87.t0) {
                  _context87.next = 10;
                  break;
                }

                _context87.next = 8;
                return _this23.sendRequest(s, "wc_pairingDelete", k("USER_DISCONNECTED"));

              case 8:
                _context87.next = 10;
                return _this23.deletePairing(s);

              case 10:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87);
      }));

      return function (_x79) {
        return _ref56.apply(this, arguments);
      };
    }(), this.sendRequest = /*#__PURE__*/function () {
      var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(i, s, n) {
        var a, o, h;
        return _regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                a = xe(s, n);
                _context88.next = 3;
                return _this23.core.crypto.encode(i, a);

              case 3:
                o = _context88.sent;
                h = F[s].req;
                return _context88.abrupt("return", (_this23.core.history.set(i, a), _this23.core.relayer.publish(i, o, h), a.id));

              case 6:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88);
      }));

      return function (_x80, _x81, _x82) {
        return _ref57.apply(this, arguments);
      };
    }(), this.sendResult = /*#__PURE__*/function () {
      var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89(i, s, n) {
        var a, o, h, u;
        return _regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                a = Oe(i, n);
                _context89.next = 3;
                return _this23.core.crypto.encode(s, a);

              case 3:
                o = _context89.sent;
                _context89.next = 6;
                return _this23.core.history.get(s, i);

              case 6:
                h = _context89.sent;
                u = F[h.request.method].res;
                _context89.next = 10;
                return _this23.core.relayer.publish(s, o, u);

              case 10:
                _context89.next = 12;
                return _this23.core.history.resolve(a);

              case 12:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89);
      }));

      return function (_x83, _x84, _x85) {
        return _ref58.apply(this, arguments);
      };
    }(), this.sendError = /*#__PURE__*/function () {
      var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90(i, s, n) {
        var a, o, h, u;
        return _regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                a = Fi(i, n);
                _context90.next = 3;
                return _this23.core.crypto.encode(s, a);

              case 3:
                o = _context90.sent;
                _context90.next = 6;
                return _this23.core.history.get(s, i);

              case 6:
                h = _context90.sent;
                u = F[h.request.method] ? F[h.request.method].res : F.unregistered_method.res;
                _context90.next = 10;
                return _this23.core.relayer.publish(s, o, u);

              case 10:
                _context90.next = 12;
                return _this23.core.history.resolve(a);

              case 12:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90);
      }));

      return function (_x86, _x87, _x88) {
        return _ref59.apply(this, arguments);
      };
    }(), this.deletePairing = /*#__PURE__*/function () {
      var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(i, s) {
        return _regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                _context91.next = 2;
                return _this23.core.relayer.unsubscribe(i);

              case 2:
                _context91.next = 4;
                return Promise.all([_this23.pairings.delete(i, k("USER_DISCONNECTED")), _this23.core.crypto.deleteSymKey(i), s ? Promise.resolve() : _this23.core.expirer.del(i)]);

              case 4:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91);
      }));

      return function (_x89, _x90) {
        return _ref60.apply(this, arguments);
      };
    }(), this.cleanup = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92() {
      var i;
      return _regeneratorRuntime.wrap(function _callee92$(_context92) {
        while (1) {
          switch (_context92.prev = _context92.next) {
            case 0:
              i = _this23.pairings.getAll().filter(function (s) {
                return Ie(s.expiry);
              });
              _context92.next = 3;
              return Promise.all(i.map(function (s) {
                return _this23.deletePairing(s.topic);
              }));

            case 3:
            case "end":
              return _context92.stop();
          }
        }
      }, _callee92);
    })), this.onRelayEventRequest = function (i) {
      var s = i.topic,
          n = i.payload;

      switch (n.method) {
        case "wc_pairingPing":
          return _this23.onPairingPingRequest(s, n);

        case "wc_pairingDelete":
          return _this23.onPairingDeleteRequest(s, n);

        default:
          return _this23.onUnknownRpcMethodRequest(s, n);
      }
    }, this.onRelayEventResponse = /*#__PURE__*/function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(i) {
        var s, n, a;
        return _regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                s = i.topic;
                n = i.payload;
                _context93.next = 4;
                return _this23.core.history.get(s, n.id);

              case 4:
                a = _context93.sent.request.method;
                _context93.t0 = a;
                _context93.next = _context93.t0 === "wc_pairingPing" ? 8 : 9;
                break;

              case 8:
                return _context93.abrupt("return", _this23.onPairingPingResponse(s, n));

              case 9:
                return _context93.abrupt("return", _this23.onUnknownRpcMethodResponse(a));

              case 10:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93);
      }));

      return function (_x91) {
        return _ref62.apply(this, arguments);
      };
    }(), this.onPairingPingRequest = /*#__PURE__*/function () {
      var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(i, s) {
        var n;
        return _regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                n = s.id;
                _context94.prev = 1;

                _this23.isValidPing({
                  topic: i
                });

                _context94.next = 5;
                return _this23.sendResult(n, i, !0);

              case 5:
                _this23.events.emit(B.ping, {
                  id: n,
                  topic: i
                });

                _context94.next = 13;
                break;

              case 8:
                _context94.prev = 8;
                _context94.t0 = _context94["catch"](1);
                _context94.next = 12;
                return _this23.sendError(n, i, _context94.t0);

              case 12:
                _this23.logger.error(_context94.t0);

              case 13:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, null, [[1, 8]]);
      }));

      return function (_x92, _x93) {
        return _ref63.apply(this, arguments);
      };
    }(), this.onPairingPingResponse = function (i, s) {
      var n = s.id;
      setTimeout(function () {
        $i(s) ? _this23.events.emit(ne("pairing_ping", n), {}) : Ae(s) && _this23.events.emit(ne("pairing_ping", n), {
          error: s.error
        });
      }, 500);
    }, this.onPairingDeleteRequest = /*#__PURE__*/function () {
      var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(i, s) {
        var n;
        return _regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                n = s.id;
                _context95.prev = 1;

                _this23.isValidDisconnect({
                  topic: i
                });

                _context95.next = 5;
                return _this23.deletePairing(i);

              case 5:
                _this23.events.emit(B.delete, {
                  id: n,
                  topic: i
                });

                _context95.next = 13;
                break;

              case 8:
                _context95.prev = 8;
                _context95.t0 = _context95["catch"](1);
                _context95.next = 12;
                return _this23.sendError(n, i, _context95.t0);

              case 12:
                _this23.logger.error(_context95.t0);

              case 13:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, null, [[1, 8]]);
      }));

      return function (_x94, _x95) {
        return _ref64.apply(this, arguments);
      };
    }(), this.onUnknownRpcMethodRequest = /*#__PURE__*/function () {
      var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(i, s) {
        var n, a, o;
        return _regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                n = s.id, a = s.method;
                _context96.prev = 1;

                if (!_this23.registeredMethods.includes(a)) {
                  _context96.next = 4;
                  break;
                }

                return _context96.abrupt("return");

              case 4:
                o = k("WC_METHOD_UNSUPPORTED", a);
                _context96.next = 7;
                return _this23.sendError(n, i, o);

              case 7:
                _this23.logger.error(o);

                _context96.next = 15;
                break;

              case 10:
                _context96.prev = 10;
                _context96.t0 = _context96["catch"](1);
                _context96.next = 14;
                return _this23.sendError(n, i, _context96.t0);

              case 14:
                _this23.logger.error(_context96.t0);

              case 15:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, null, [[1, 10]]);
      }));

      return function (_x96, _x97) {
        return _ref65.apply(this, arguments);
      };
    }(), this.onUnknownRpcMethodResponse = function (i) {
      _this23.registeredMethods.includes(i) || _this23.logger.error(k("WC_METHOD_UNSUPPORTED", i));
    }, this.isValidPair = function (i) {
      if (!ae(i)) {
        var _l12 = l("MISSING_OR_INVALID", "pair() params: ".concat(i)),
            s = _l12.message;

        throw new Error(s);
      }

      if (!Ii(i.uri)) {
        var _l13 = l("MISSING_OR_INVALID", "pair() uri: ".concat(i.uri)),
            _s2 = _l13.message;

        throw new Error(_s2);
      }
    }, this.isValidPing = /*#__PURE__*/function () {
      var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97(i) {
        var _l14, n, s;

        return _regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                if (ae(i)) {
                  _context97.next = 3;
                  break;
                }

                _l14 = l("MISSING_OR_INVALID", "ping() params: ".concat(i)), n = _l14.message;
                throw new Error(n);

              case 3:
                s = i.topic;
                _context97.next = 6;
                return _this23.isValidPairingTopic(s);

              case 6:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97);
      }));

      return function (_x98) {
        return _ref66.apply(this, arguments);
      };
    }(), this.isValidDisconnect = /*#__PURE__*/function () {
      var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98(i) {
        var _l15, n, s;

        return _regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                if (ae(i)) {
                  _context98.next = 3;
                  break;
                }

                _l15 = l("MISSING_OR_INVALID", "disconnect() params: ".concat(i)), n = _l15.message;
                throw new Error(n);

              case 3:
                s = i.topic;
                _context98.next = 6;
                return _this23.isValidPairingTopic(s);

              case 6:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98);
      }));

      return function (_x99) {
        return _ref67.apply(this, arguments);
      };
    }(), this.isValidPairingTopic = /*#__PURE__*/function () {
      var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99(i) {
        var _l16, s, _l17, _s3, _l18, _s4;

        return _regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                if (Ci(i, !1)) {
                  _context99.next = 3;
                  break;
                }

                _l16 = l("MISSING_OR_INVALID", "pairing topic should be a string: ".concat(i)), s = _l16.message;
                throw new Error(s);

              case 3:
                if (_this23.pairings.keys.includes(i)) {
                  _context99.next = 6;
                  break;
                }

                _l17 = l("NO_MATCHING_KEY", "pairing topic doesn't exist: ".concat(i)), _s3 = _l17.message;
                throw new Error(_s3);

              case 6:
                if (!Ie(_this23.pairings.get(i).expiry)) {
                  _context99.next = 11;
                  break;
                }

                _context99.next = 9;
                return _this23.deletePairing(i);

              case 9:
                _l18 = l("EXPIRED", "pairing topic: ".concat(i)), _s4 = _l18.message;
                throw new Error(_s4);

              case 11:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99);
      }));

      return function (_x100) {
        return _ref68.apply(this, arguments);
      };
    }(), this.core = e, this.logger = f(t, this.name), this.pairings = new Ft(this.core, this.logger, this.name, this.storagePrefix);
  }

  _createClass($t, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l19 = l("NOT_INITIALIZED", this.name),
            e = _l19.message;

        throw new Error(e);
      }
    }
  }, {
    key: "registerRelayerEvents",
    value: function registerRelayerEvents() {
      var _this24 = this;

      this.core.relayer.on(D.message, /*#__PURE__*/function () {
        var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100(e) {
          var t, i, s;
          return _regeneratorRuntime.wrap(function _callee100$(_context100) {
            while (1) {
              switch (_context100.prev = _context100.next) {
                case 0:
                  t = e.topic, i = e.message;

                  if (!(!_this24.pairings.keys.includes(t) || _this24.ignoredPayloadTypes.includes(_this24.core.crypto.getPayloadType(i)))) {
                    _context100.next = 3;
                    break;
                  }

                  return _context100.abrupt("return");

                case 3:
                  _context100.next = 5;
                  return _this24.core.crypto.decode(t, i);

                case 5:
                  s = _context100.sent;
                  _context100.prev = 6;

                  if (!Se(s)) {
                    _context100.next = 11;
                    break;
                  }

                  _this24.core.history.set(t, s), _this24.onRelayEventRequest({
                    topic: t,
                    payload: s
                  });
                  _context100.next = 18;
                  break;

                case 11:
                  _context100.t0 = Pe(s);

                  if (!_context100.t0) {
                    _context100.next = 18;
                    break;
                  }

                  _context100.next = 15;
                  return _this24.core.history.resolve(s);

                case 15:
                  _context100.next = 17;
                  return _this24.onRelayEventResponse({
                    topic: t,
                    payload: s
                  });

                case 17:
                  _this24.core.history.delete(t, s.id);

                case 18:
                  _context100.next = 23;
                  break;

                case 20:
                  _context100.prev = 20;
                  _context100.t1 = _context100["catch"](6);

                  _this24.logger.error(_context100.t1);

                case 23:
                case "end":
                  return _context100.stop();
              }
            }
          }, _callee100, null, [[6, 20]]);
        }));

        return function (_x101) {
          return _ref69.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerExpirerEvents",
    value: function registerExpirerEvents() {
      var _this25 = this;

      this.core.expirer.on(w.expired, /*#__PURE__*/function () {
        var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101(e) {
          var _Ri, t;

          return _regeneratorRuntime.wrap(function _callee101$(_context101) {
            while (1) {
              switch (_context101.prev = _context101.next) {
                case 0:
                  _Ri = Ri(e.target), t = _Ri.topic;
                  _context101.t0 = t && _this25.pairings.keys.includes(t);

                  if (!_context101.t0) {
                    _context101.next = 6;
                    break;
                  }

                  _context101.next = 5;
                  return _this25.deletePairing(t, !0);

                case 5:
                  _this25.events.emit(B.expire, {
                    topic: t
                  });

                case 6:
                case "end":
                  return _context101.stop();
              }
            }
          }, _callee101);
        }));

        return function (_x102) {
          return _ref70.apply(this, arguments);
        };
      }());
    }
  }]);

  return $t;
}();

var Mt = /*#__PURE__*/function (_Zt) {
  _inherits(Mt, _Zt);

  var _super6 = _createSuper(Mt);

  function Mt(e, t) {
    var _this26;

    _classCallCheck(this, Mt);

    _this26 = _super6.call(this, e, t), _this26.core = e, _this26.logger = t, _this26.records = new Map(), _this26.events = new N(), _this26.name = wt, _this26.version = vt, _this26.cached = [], _this26.initialized = !1, _this26.storagePrefix = x, _this26.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102() {
      return _regeneratorRuntime.wrap(function _callee102$(_context102) {
        while (1) {
          switch (_context102.prev = _context102.next) {
            case 0:
              _context102.t0 = _this26.initialized;

              if (_context102.t0) {
                _context102.next = 9;
                break;
              }

              _this26.logger.trace("Initialized");

              _context102.next = 5;
              return _this26.restore();

            case 5:
              _this26.cached.forEach(function (i) {
                return _this26.records.set(i.id, i);
              });

              _this26.cached = [];

              _this26.registerEventListeners();

              _this26.initialized = !0;

            case 9:
            case "end":
              return _context102.stop();
          }
        }
      }, _callee102);
    })), _this26.set = function (i, s, n) {
      if (_this26.isInitialized(), _this26.logger.debug("Setting JSON-RPC request history record"), _this26.logger.trace({
        type: "method",
        method: "set",
        topic: i,
        request: s,
        chainId: n
      }), _this26.records.has(s.id)) return;
      var a = {
        id: s.id,
        topic: i,
        request: {
          method: s.method,
          params: s.params || null
        },
        chainId: n,
        expiry: H(J)
      };
      _this26.records.set(a.id, a), _this26.events.emit(R.created, a);
    }, _this26.resolve = /*#__PURE__*/function () {
      var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(i) {
        var s;
        return _regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                if (!(_this26.isInitialized(), _this26.logger.debug("Updating JSON-RPC response history record"), _this26.logger.trace({
                  type: "method",
                  method: "update",
                  response: i
                }), !_this26.records.has(i.id))) {
                  _context103.next = 2;
                  break;
                }

                return _context103.abrupt("return");

              case 2:
                _context103.next = 4;
                return _this26.getRecord(i.id);

              case 4:
                s = _context103.sent;
                typeof s.response > "u" && (s.response = Ae(i) ? {
                  error: i.error
                } : {
                  result: i.result
                }, _this26.records.set(s.id, s), _this26.events.emit(R.updated, s));

              case 6:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103);
      }));

      return function (_x103) {
        return _ref72.apply(this, arguments);
      };
    }(), _this26.get = /*#__PURE__*/function () {
      var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(i, s) {
        return _regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _this26.isInitialized();

                _this26.logger.debug("Getting record");

                _this26.logger.trace({
                  type: "method",
                  method: "get",
                  topic: i,
                  id: s
                });

                _context104.next = 5;
                return _this26.getRecord(s);

              case 5:
                return _context104.abrupt("return", _context104.sent);

              case 6:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104);
      }));

      return function (_x104, _x105) {
        return _ref73.apply(this, arguments);
      };
    }(), _this26.delete = function (i, s) {
      _this26.isInitialized(), _this26.logger.debug("Deleting record"), _this26.logger.trace({
        type: "method",
        method: "delete",
        id: s
      }), _this26.values.forEach(function (n) {
        if (n.topic === i) {
          if (typeof s < "u" && n.id !== s) return;
          _this26.records.delete(n.id), _this26.events.emit(R.deleted, n);
        }
      });
    }, _this26.exists = /*#__PURE__*/function () {
      var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(i, s) {
        return _regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                _this26.isInitialized();

                if (!_this26.records.has(s)) {
                  _context105.next = 9;
                  break;
                }

                _context105.next = 4;
                return _this26.getRecord(s);

              case 4:
                _context105.t1 = _context105.sent.topic;
                _context105.t2 = i;
                _context105.t0 = _context105.t1 === _context105.t2;
                _context105.next = 10;
                break;

              case 9:
                _context105.t0 = !1;

              case 10:
                return _context105.abrupt("return", _context105.t0);

              case 11:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105);
      }));

      return function (_x106, _x107) {
        return _ref74.apply(this, arguments);
      };
    }(), _this26.on = function (i, s) {
      _this26.events.on(i, s);
    }, _this26.once = function (i, s) {
      _this26.events.once(i, s);
    }, _this26.off = function (i, s) {
      _this26.events.off(i, s);
    }, _this26.removeListener = function (i, s) {
      _this26.events.removeListener(i, s);
    }, _this26.logger = f(t, _this26.name);
    return _this26;
  }

  _createClass(Mt, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "size",
    get: function get() {
      return this.records.size;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.records.keys());
    }
  }, {
    key: "values",
    get: function get() {
      return Array.from(this.records.values());
    }
  }, {
    key: "pending",
    get: function get() {
      var e = [];
      return this.values.forEach(function (t) {
        if (typeof t.response < "u") return;
        var i = {
          topic: t.topic,
          request: xe(t.request.method, t.request.params, t.id),
          chainId: t.chainId
        };
        return e.push(i);
      }), e;
    }
  }, {
    key: "setJsonRpcRecords",
    value: function () {
      var _setJsonRpcRecords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(e) {
        return _regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                _context106.next = 2;
                return this.core.storage.setItem(this.storageKey, e);

              case 2:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, this);
      }));

      function setJsonRpcRecords(_x108) {
        return _setJsonRpcRecords.apply(this, arguments);
      }

      return setJsonRpcRecords;
    }()
  }, {
    key: "getJsonRpcRecords",
    value: function () {
      var _getJsonRpcRecords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107() {
        return _regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                _context107.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                return _context107.abrupt("return", _context107.sent);

              case 3:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, this);
      }));

      function getJsonRpcRecords() {
        return _getJsonRpcRecords.apply(this, arguments);
      }

      return getJsonRpcRecords;
    }()
  }, {
    key: "getRecord",
    value: function getRecord(e) {
      this.isInitialized();
      var t = this.records.get(e);

      if (!t) {
        var _l20 = l("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)),
            i = _l20.message;

        throw new Error(i);
      }

      return t;
    }
  }, {
    key: "persist",
    value: function () {
      var _persist5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108() {
        return _regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                _context108.next = 2;
                return this.setJsonRpcRecords(this.values);

              case 2:
                this.events.emit(R.sync);

              case 3:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108, this);
      }));

      function persist() {
        return _persist5.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109() {
        var e, _l21, t;

        return _regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                _context109.prev = 0;
                _context109.next = 3;
                return this.getJsonRpcRecords();

              case 3:
                e = _context109.sent;

                if (!(typeof e > "u" || !e.length)) {
                  _context109.next = 6;
                  break;
                }

                return _context109.abrupt("return");

              case 6:
                if (!this.records.size) {
                  _context109.next = 9;
                  break;
                }

                _l21 = l("RESTORE_WILL_OVERRIDE", this.name), t = _l21.message;
                throw this.logger.error(t), new Error(t);

              case 9:
                this.cached = e, this.logger.debug("Successfully Restored records for ".concat(this.name)), this.logger.trace({
                  type: "method",
                  method: "restore",
                  records: this.values
                });
                _context109.next = 15;
                break;

              case 12:
                _context109.prev = 12;
                _context109.t0 = _context109["catch"](0);
                this.logger.debug("Failed to Restore records for ".concat(this.name)), this.logger.error(_context109.t0);

              case 15:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, this, [[0, 12]]);
      }));

      function restore() {
        return _restore3.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this27 = this;

      this.events.on(R.created, function (e) {
        var t = R.created;
        _this27.logger.info("Emitting ".concat(t)), _this27.logger.debug({
          type: "event",
          event: t,
          record: e
        }), _this27.persist();
      }), this.events.on(R.updated, function (e) {
        var t = R.updated;
        _this27.logger.info("Emitting ".concat(t)), _this27.logger.debug({
          type: "event",
          event: t,
          record: e
        }), _this27.persist();
      }), this.events.on(R.deleted, function (e) {
        var t = R.deleted;
        _this27.logger.info("Emitting ".concat(t)), _this27.logger.debug({
          type: "event",
          event: t,
          record: e
        }), _this27.persist();
      }), this.core.heartbeat.on(j.pulse, function () {
        _this27.cleanup();
      });
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _this28 = this;

      try {
        this.records.forEach(function (e) {
          L(e.expiry || 0) - Date.now() <= 0 && (_this28.logger.info("Deleting expired history log: ".concat(e.id)), _this28.delete(e.topic, e.id));
        });
      } catch (e) {
        this.logger.warn(e);
      }
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l22 = l("NOT_INITIALIZED", this.name),
            e = _l22.message;

        throw new Error(e);
      }
    }
  }]);

  return Mt;
}(Zt);

var kt = /*#__PURE__*/function (_ei) {
  _inherits(kt, _ei);

  var _super7 = _createSuper(kt);

  function kt(e, t) {
    var _this29;

    _classCallCheck(this, kt);

    _this29 = _super7.call(this, e, t), _this29.core = e, _this29.logger = t, _this29.expirations = new Map(), _this29.events = new N(), _this29.name = It, _this29.version = Ct, _this29.cached = [], _this29.initialized = !1, _this29.storagePrefix = x, _this29.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110() {
      return _regeneratorRuntime.wrap(function _callee110$(_context110) {
        while (1) {
          switch (_context110.prev = _context110.next) {
            case 0:
              _context110.t0 = _this29.initialized;

              if (_context110.t0) {
                _context110.next = 9;
                break;
              }

              _this29.logger.trace("Initialized");

              _context110.next = 5;
              return _this29.restore();

            case 5:
              _this29.cached.forEach(function (i) {
                return _this29.expirations.set(i.target, i);
              });

              _this29.cached = [];

              _this29.registerEventListeners();

              _this29.initialized = !0;

            case 9:
            case "end":
              return _context110.stop();
          }
        }
      }, _callee110);
    })), _this29.has = function (i) {
      try {
        var s = _this29.formatTarget(i);

        return typeof _this29.getExpiration(s) < "u";
      } catch (_unused6) {
        return !1;
      }
    }, _this29.set = function (i, s) {
      _this29.isInitialized();

      var n = _this29.formatTarget(i),
          a = {
        target: n,
        expiry: s
      };

      _this29.expirations.set(n, a), _this29.checkExpiry(n, a), _this29.events.emit(w.created, {
        target: n,
        expiration: a
      });
    }, _this29.get = function (i) {
      _this29.isInitialized();

      var s = _this29.formatTarget(i);

      return _this29.getExpiration(s);
    }, _this29.del = function (i) {
      if (_this29.isInitialized(), _this29.has(i)) {
        var s = _this29.formatTarget(i),
            n = _this29.getExpiration(s);

        _this29.expirations.delete(s), _this29.events.emit(w.deleted, {
          target: s,
          expiration: n
        });
      }
    }, _this29.on = function (i, s) {
      _this29.events.on(i, s);
    }, _this29.once = function (i, s) {
      _this29.events.once(i, s);
    }, _this29.off = function (i, s) {
      _this29.events.off(i, s);
    }, _this29.removeListener = function (i, s) {
      _this29.events.removeListener(i, s);
    }, _this29.logger = f(t, _this29.name);
    return _this29;
  }

  _createClass(kt, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "storageKey",
    get: function get() {
      return this.storagePrefix + this.version + "//" + this.name;
    }
  }, {
    key: "length",
    get: function get() {
      return this.expirations.size;
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.expirations.keys());
    }
  }, {
    key: "values",
    get: function get() {
      return Array.from(this.expirations.values());
    }
  }, {
    key: "formatTarget",
    value: function formatTarget(e) {
      if (typeof e == "string") return _i(e);
      if (typeof e == "number") return Ti(e);

      var _l23 = l("UNKNOWN_TYPE", "Target type: ".concat(typeof e)),
          t = _l23.message;

      throw new Error(t);
    }
  }, {
    key: "setExpirations",
    value: function () {
      var _setExpirations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111(e) {
        return _regeneratorRuntime.wrap(function _callee111$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                _context111.next = 2;
                return this.core.storage.setItem(this.storageKey, e);

              case 2:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee111, this);
      }));

      function setExpirations(_x109) {
        return _setExpirations.apply(this, arguments);
      }

      return setExpirations;
    }()
  }, {
    key: "getExpirations",
    value: function () {
      var _getExpirations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112() {
        return _regeneratorRuntime.wrap(function _callee112$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                _context112.next = 2;
                return this.core.storage.getItem(this.storageKey);

              case 2:
                return _context112.abrupt("return", _context112.sent);

              case 3:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee112, this);
      }));

      function getExpirations() {
        return _getExpirations.apply(this, arguments);
      }

      return getExpirations;
    }()
  }, {
    key: "persist",
    value: function () {
      var _persist6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113() {
        return _regeneratorRuntime.wrap(function _callee113$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                _context113.next = 2;
                return this.setExpirations(this.values);

              case 2:
                this.events.emit(w.sync);

              case 3:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee113, this);
      }));

      function persist() {
        return _persist6.apply(this, arguments);
      }

      return persist;
    }()
  }, {
    key: "restore",
    value: function () {
      var _restore4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee114() {
        var e, _l24, t;

        return _regeneratorRuntime.wrap(function _callee114$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                _context114.prev = 0;
                _context114.next = 3;
                return this.getExpirations();

              case 3:
                e = _context114.sent;

                if (!(typeof e > "u" || !e.length)) {
                  _context114.next = 6;
                  break;
                }

                return _context114.abrupt("return");

              case 6:
                if (!this.expirations.size) {
                  _context114.next = 9;
                  break;
                }

                _l24 = l("RESTORE_WILL_OVERRIDE", this.name), t = _l24.message;
                throw this.logger.error(t), new Error(t);

              case 9:
                this.cached = e, this.logger.debug("Successfully Restored expirations for ".concat(this.name)), this.logger.trace({
                  type: "method",
                  method: "restore",
                  expirations: this.values
                });
                _context114.next = 15;
                break;

              case 12:
                _context114.prev = 12;
                _context114.t0 = _context114["catch"](0);
                this.logger.debug("Failed to Restore expirations for ".concat(this.name)), this.logger.error(_context114.t0);

              case 15:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee114, this, [[0, 12]]);
      }));

      function restore() {
        return _restore4.apply(this, arguments);
      }

      return restore;
    }()
  }, {
    key: "getExpiration",
    value: function getExpiration(e) {
      var t = this.expirations.get(e);

      if (!t) {
        var _l25 = l("NO_MATCHING_KEY", "".concat(this.name, ": ").concat(e)),
            i = _l25.message;

        throw this.logger.error(i), new Error(i);
      }

      return t;
    }
  }, {
    key: "checkExpiry",
    value: function checkExpiry(e, t) {
      var i = t.expiry;
      L(i) - Date.now() <= 0 && this.expire(e, t);
    }
  }, {
    key: "expire",
    value: function expire(e, t) {
      this.expirations.delete(e), this.events.emit(w.expired, {
        target: e,
        expiration: t
      });
    }
  }, {
    key: "checkExpirations",
    value: function checkExpirations() {
      var _this30 = this;

      this.core.relayer.connected && this.expirations.forEach(function (e, t) {
        return _this30.checkExpiry(t, e);
      });
    }
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this31 = this;

      this.core.heartbeat.on(j.pulse, function () {
        return _this31.checkExpirations();
      }), this.events.on(w.created, function (e) {
        var t = w.created;
        _this31.logger.info("Emitting ".concat(t)), _this31.logger.debug({
          type: "event",
          event: t,
          data: e
        }), _this31.persist();
      }), this.events.on(w.expired, function (e) {
        var t = w.expired;
        _this31.logger.info("Emitting ".concat(t)), _this31.logger.debug({
          type: "event",
          event: t,
          data: e
        }), _this31.persist();
      }), this.events.on(w.deleted, function (e) {
        var t = w.deleted;
        _this31.logger.info("Emitting ".concat(t)), _this31.logger.debug({
          type: "event",
          event: t,
          data: e
        }), _this31.persist();
      });
    }
  }, {
    key: "isInitialized",
    value: function isInitialized() {
      if (!this.initialized) {
        var _l26 = l("NOT_INITIALIZED", this.name),
            e = _l26.message;

        throw new Error(e);
      }
    }
  }]);

  return kt;
}(ei);

var Kt = /*#__PURE__*/function (_ti) {
  _inherits(Kt, _ti);

  var _super8 = _createSuper(Kt);

  function Kt(e, t) {
    var _this32;

    _classCallCheck(this, Kt);

    _this32 = _super8.call(this, e, t), _this32.projectId = e, _this32.logger = t, _this32.name = Q, _this32.initialized = !1, _this32.queue = [], _this32.verifyDisabled = !1, _this32.init = /*#__PURE__*/function () {
      var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee115(i) {
        var s;
        return _regeneratorRuntime.wrap(function _callee115$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                if (!(_this32.verifyDisabled || Si() || !Pi())) {
                  _context115.next = 2;
                  break;
                }

                return _context115.abrupt("return");

              case 2:
                s = (i === null || i === void 0 ? void 0 : i.verifyUrl) || Z;
                _this32.verifyUrl !== s && _this32.removeIframe(), _this32.verifyUrl = s;
                _context115.prev = 4;
                _context115.next = 7;
                return _this32.createIframe();

              case 7:
                _context115.next = 12;
                break;

              case 9:
                _context115.prev = 9;
                _context115.t0 = _context115["catch"](4);
                _this32.logger.info("Verify iframe failed to load: ".concat(_this32.verifyUrl)), _this32.logger.info(_context115.t0);

              case 12:
                if (_this32.initialized) {
                  _context115.next = 22;
                  break;
                }

                _this32.removeIframe(), _this32.verifyUrl = pe;
                _context115.prev = 14;
                _context115.next = 17;
                return _this32.createIframe();

              case 17:
                _context115.next = 22;
                break;

              case 19:
                _context115.prev = 19;
                _context115.t1 = _context115["catch"](14);
                _this32.logger.info("Verify iframe failed to load: ".concat(_this32.verifyUrl)), _this32.logger.info(_context115.t1), _this32.verifyDisabled = !0;

              case 22:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee115, null, [[4, 9], [14, 19]]);
      }));

      return function (_x110) {
        return _ref76.apply(this, arguments);
      };
    }(), _this32.register = /*#__PURE__*/function () {
      var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee116(i) {
        return _regeneratorRuntime.wrap(function _callee116$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                if (!_this32.initialized) {
                  _context116.next = 4;
                  break;
                }

                _this32.sendPost(i.attestationId);

                _context116.next = 7;
                break;

              case 4:
                _this32.addToQueue(i.attestationId);

                _context116.next = 7;
                return _this32.init();

              case 7:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee116);
      }));

      return function (_x111) {
        return _ref77.apply(this, arguments);
      };
    }(), _this32.resolve = /*#__PURE__*/function () {
      var _ref78 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee117(i) {
        var s, n;
        return _regeneratorRuntime.wrap(function _callee117$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                if (!_this32.isDevEnv) {
                  _context117.next = 2;
                  break;
                }

                return _context117.abrupt("return", "");

              case 2:
                s = (i === null || i === void 0 ? void 0 : i.verifyUrl) || Z;
                _context117.prev = 3;
                _context117.next = 6;
                return _this32.fetchAttestation(i.attestationId, s);

              case 6:
                n = _context117.sent;
                _context117.next = 16;
                break;

              case 9:
                _context117.prev = 9;
                _context117.t0 = _context117["catch"](3);

                _this32.logger.info("failed to resolve attestation: ".concat(i.attestationId, " from url: ").concat(s));

                _this32.logger.info(_context117.t0);

                _context117.next = 15;
                return _this32.fetchAttestation(i.attestationId, pe);

              case 15:
                n = _context117.sent;

              case 16:
                return _context117.abrupt("return", n);

              case 17:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee117, null, [[3, 9]]);
      }));

      return function (_x112) {
        return _ref78.apply(this, arguments);
      };
    }(), _this32.fetchAttestation = /*#__PURE__*/function () {
      var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee118(i, s) {
        var n, a;
        return _regeneratorRuntime.wrap(function _callee118$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                _this32.logger.info("resolving attestation: ".concat(i, " from url: ").concat(s));

                n = _this32.startAbortTimer(Ce * 2);
                _context118.next = 4;
                return fetch("".concat(s, "/attestation/").concat(i), {
                  signal: _this32.abortController.signal
                });

              case 4:
                a = _context118.sent;
                clearTimeout(n);

                if (!(a.status === 200)) {
                  _context118.next = 12;
                  break;
                }

                _context118.next = 9;
                return a.json();

              case 9:
                _context118.t0 = _context118.sent;
                _context118.next = 13;
                break;

              case 12:
                _context118.t0 = void 0;

              case 13:
                return _context118.abrupt("return", _context118.t0);

              case 14:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee118);
      }));

      return function (_x113, _x114) {
        return _ref79.apply(this, arguments);
      };
    }(), _this32.addToQueue = function (i) {
      _this32.queue.push(i);
    }, _this32.processQueue = function () {
      _this32.queue.length !== 0 && (_this32.queue.forEach(function (i) {
        return _this32.sendPost(i);
      }), _this32.queue = []);
    }, _this32.sendPost = function (i) {
      var s;

      try {
        if (!_this32.iframe) return;
        (s = _this32.iframe.contentWindow) == null || s.postMessage(i, "*"), _this32.logger.info("postMessage sent: ".concat(i, " ").concat(_this32.verifyUrl));
      } catch (_unused7) {}
    }, _this32.createIframe = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee119() {
      var i, s;
      return _regeneratorRuntime.wrap(function _callee119$(_context119) {
        while (1) {
          switch (_context119.prev = _context119.next) {
            case 0:
              s = function s(n) {
                n.data === "verify_ready" && (_this32.initialized = !0, _this32.processQueue(), window.removeEventListener("message", s), i());
              };

              _context119.next = 3;
              return Promise.race([new Promise(function (n) {
                if (document.getElementById(Q)) return n();
                window.addEventListener("message", s);
                var a = document.createElement("iframe");
                a.id = Q, a.src = "".concat(_this32.verifyUrl, "/").concat(_this32.projectId), a.style.display = "none", document.body.append(a), _this32.iframe = a, i = n;
              }), new Promise(function (n, a) {
                return setTimeout(function () {
                  window.removeEventListener("message", s), a("verify iframe load timeout");
                }, L(Re));
              })]);

            case 3:
            case "end":
              return _context119.stop();
          }
        }
      }, _callee119);
    })), _this32.removeIframe = function () {
      _this32.iframe && (_this32.iframe.remove(), _this32.iframe = void 0, _this32.initialized = !1);
    }, _this32.logger = f(t, _this32.name), _this32.verifyUrl = Z, _this32.abortController = new AbortController(), _this32.isDevEnv = Oi() && process.env.IS_VITEST;
    return _this32;
  }

  _createClass(Kt, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "startAbortTimer",
    value: function startAbortTimer(e) {
      var _this33 = this;

      return this.abortController = new AbortController(), setTimeout(function () {
        return _this33.abortController.abort();
      }, L(e));
    }
  }]);

  return Kt;
}(ti);

var Pr = Object.defineProperty,
    Bt = Object.getOwnPropertySymbols,
    Or = Object.prototype.hasOwnProperty,
    xr = Object.prototype.propertyIsEnumerable,
    Vt = function Vt(r, e, t) {
  return e in r ? Pr(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t;
},
    qt = function qt(r, e) {
  for (var t in e || (e = {})) {
    Or.call(e, t) && Vt(r, t, e[t]);
  }

  if (Bt) {
    var _iterator5 = _createForOfIteratorHelper(Bt(e)),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var t = _step5.value;
        xr.call(e, t) && Vt(r, t, e[t]);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  return r;
};

var ee = /*#__PURE__*/function (_ii) {
  _inherits(ee, _ii);

  var _super9 = _createSuper(ee);

  function ee(e) {
    var _this34;

    _classCallCheck(this, ee);

    _this34 = _super9.call(this, e), _this34.protocol = ue, _this34.version = We, _this34.name = X, _this34.events = new N(), _this34.initialized = !1, _this34.on = function (i, s) {
      return _this34.events.on(i, s);
    }, _this34.once = function (i, s) {
      return _this34.events.once(i, s);
    }, _this34.off = function (i, s) {
      return _this34.events.off(i, s);
    }, _this34.removeListener = function (i, s) {
      return _this34.events.removeListener(i, s);
    }, _this34.projectId = e === null || e === void 0 ? void 0 : e.projectId, _this34.relayUrl = (e === null || e === void 0 ? void 0 : e.relayUrl) || de;
    var t = typeof (e === null || e === void 0 ? void 0 : e.logger) < "u" && typeof (e === null || e === void 0 ? void 0 : e.logger) != "string" ? e.logger : ye(be({
      level: (e === null || e === void 0 ? void 0 : e.logger) || Xe.logger
    }));
    _this34.logger = f(t, _this34.name), _this34.heartbeat = new Gt(), _this34.crypto = new _t(_assertThisInitialized(_this34), _this34.logger, e === null || e === void 0 ? void 0 : e.keychain), _this34.history = new Mt(_assertThisInitialized(_this34), _this34.logger), _this34.expirer = new kt(_assertThisInitialized(_this34), _this34.logger), _this34.storage = e != null && e.storage ? e.storage : new Yt(qt(qt({}, Qe), e === null || e === void 0 ? void 0 : e.storageOptions)), _this34.relayer = new zt({
      core: _assertThisInitialized(_this34),
      logger: _this34.logger,
      relayUrl: _this34.relayUrl,
      projectId: _this34.projectId
    }), _this34.pairing = new $t(_assertThisInitialized(_this34), _this34.logger), _this34.verify = new Kt(_this34.projectId || "", _this34.logger);
    return _this34;
  }

  _createClass(ee, [{
    key: "context",
    get: function get() {
      return E(this.logger);
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee120() {
        return _regeneratorRuntime.wrap(function _callee120$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                _context120.t0 = this.initialized;

                if (_context120.t0) {
                  _context120.next = 4;
                  break;
                }

                _context120.next = 4;
                return this.initialize();

              case 4:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee120, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee121() {
        return _regeneratorRuntime.wrap(function _callee121$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                this.logger.trace("Initialized");
                _context121.prev = 1;
                _context121.next = 4;
                return this.crypto.init();

              case 4:
                _context121.next = 6;
                return this.history.init();

              case 6:
                _context121.next = 8;
                return this.expirer.init();

              case 8:
                _context121.next = 10;
                return this.relayer.init();

              case 10:
                _context121.next = 12;
                return this.heartbeat.init();

              case 12:
                _context121.next = 14;
                return this.pairing.init();

              case 14:
                this.initialized = !0;
                this.logger.info("Core Initialization Success");
                _context121.next = 21;
                break;

              case 18:
                _context121.prev = 18;
                _context121.t0 = _context121["catch"](1);
                throw this.logger.warn("Core Initialization Failure at epoch ".concat(Date.now()), _context121.t0), this.logger.error(_context121.t0.message), _context121.t0;

              case 21:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee121, this, [[1, 18]]);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }], [{
    key: "init",
    value: function () {
      var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee122(e) {
        var t, i;
        return _regeneratorRuntime.wrap(function _callee122$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                t = new ee(e);
                _context122.next = 3;
                return t.initialize();

              case 3:
                _context122.next = 5;
                return t.crypto.getClientId();

              case 5:
                i = _context122.sent;
                _context122.next = 8;
                return t.storage.setItem(Dt, i);

              case 8:
                return _context122.abrupt("return", t);

              case 9:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee122);
      }));

      function init(_x115) {
        return _init2.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return ee;
}(ii);

var Ar = ee;
export { X as CORE_CONTEXT, Xe as CORE_DEFAULT, ue as CORE_PROTOCOL, Qe as CORE_STORAGE_OPTIONS, x as CORE_STORAGE_PREFIX, We as CORE_VERSION, le as CRYPTO_CLIENT_SEED, Ze as CRYPTO_CONTEXT, et as CRYPTO_JWT_TTL, Ar as Core, _t as Crypto, It as EXPIRER_CONTEXT, pr as EXPIRER_DEFAULT_TTL, w as EXPIRER_EVENTS, Ct as EXPIRER_STORAGE_VERSION, kt as Expirer, wt as HISTORY_CONTEXT, R as HISTORY_EVENTS, vt as HISTORY_STORAGE_VERSION, Mt as JsonRpcHistory, tt as KEYCHAIN_CONTEXT, it as KEYCHAIN_STORAGE_VERSION, Rt as KeyChain, st as MESSAGES_CONTEXT, rt as MESSAGES_STORAGE_VERSION, Tt as MessageTracker, ft as PAIRING_CONTEXT, gr as PAIRING_DEFAULT_TTL, B as PAIRING_EVENTS, F as PAIRING_RPC_OPTS, Et as PAIRING_STORAGE_VERSION, mt as PENDING_SUB_RESOLUTION_TIMEOUT, at as PUBLISHER_CONTEXT, nt as PUBLISHER_DEFAULT_TTL, $t as Pairing, ct as RELAYER_CONTEXT, ht as RELAYER_DEFAULT_LOGGER, ot as RELAYER_DEFAULT_PROTOCOL, de as RELAYER_DEFAULT_RELAY_URL, D as RELAYER_EVENTS, ge as RELAYER_FAILOVER_RELAY_URL, P as RELAYER_PROVIDER_EVENTS, lt as RELAYER_RECONNECT_TIMEOUT, dt as RELAYER_SDK_VERSION, lr as RELAYER_STORAGE_OPTIONS, ut as RELAYER_SUBSCRIBER_SUFFIX, gt as RELAYER_TRANSPORT_CUTOFF, zt as Relayer, pt as STORE_STORAGE_VERSION, yt as SUBSCRIBER_CONTEXT, dr as SUBSCRIBER_DEFAULT_TTL, C as SUBSCRIBER_EVENTS, bt as SUBSCRIBER_STORAGE_VERSION, Ft as Store, Ot as Subscriber, Q as VERIFY_CONTEXT, pe as VERIFY_FALLBACK_SERVER, Z as VERIFY_SERVER, Kt as Verify, Dt as WALLETCONNECT_CLIENT_ID, ee as default };